import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {ButtonGroup, ToggleButton, Button} from "react-bootstrap";
import {  IconButton, Modal, Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Card , CardHeader, CardContent, Typography, TextField, Checkbox,TextareaAutosize} from '@mui/material';
import Table from 'react-bootstrap/Table';
import { Pagination } from "react-bootstrap";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Icon from "@mui/material/Icon";
import CloseIcon from '@mui/icons-material/Close';
import "layouts/style.css"
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import Select from "react-select";
import { fetchMaterials } from "assets/globalAPI/apiGlobal";
import { approveMaterial } from "assets/globalAPI/apiGlobal";
import { createMaterial } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchKDSMaterial } from "assets/globalAPI/apiGlobal";
import { fetchKDSVendor } from "assets/globalAPI/apiGlobal";
import Tooltip from '@mui/material/Tooltip';
import { fetchAuditLog } from "assets/globalAPI/apiGlobal";
import { fetchSingleMaterial } from "assets/globalAPI/apiGlobal";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { fetchAllCustomer } from "assets/globalAPI/apiGlobal";

const customStyles = {
  control: (provided) => ({
    ...provided,
    width: 250,
    minHeight: 30,
    fontSize: "0.9rem"
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "0.85rem",
    zIndex  : 9999
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "0.85rem",
    padding: 8
  })
};

const MaterialsList=()=>{
  const toastId = React.useRef(null);
  const navigate= useNavigate()
    const [openDialog, setOpenDialog] = useState(false);
    const [openApp2, setOpenApp2] = useState(false);
    const [openApp3, setOpenApp3] = useState(false);
    const [selectedTab, setSelectedTab]= useState('details')
    const [thePlant, setThePlant]= useState('')
    const [openComment, setOpenComment] = useState(false);
    const [openComment2, setOpenComment2] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [searchLoader, setSearchLoader] = useState(false);
    const [approvalAllowed, setApprovalAllowed] = useState(false);
    const [selectedField, setSelectedField] = useState(null);
const [dialogOpen, setDialogOpen] = useState(false);
    const [comment,setComment]= useState("");
    // const [openDialog, setOpenDialog] = useState(false);
    const [user, setUser] = useState(null);
  const [isApp1, setIsApp1] = useState(false);
  const [isApp2, setIsApp2] = useState(false);
  const [isApp3, setIsApp3] = useState(false);
  const [materialStatus, setMaterialStatus]= useState("")
  const [materialCreatedBy, setMaterialCreatedBy]= useState("")
  const [materialCreatedOn, setMaterialCreatedOn]= useState("")
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch,setDebouncedSearch]= useState("");
  const [materialSearch,setMaterialSearch]= useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const typingTimeoutRef = React.useRef(null);
  const latestSearchRef = React.useRef("");
  const [approverType, setApproverType]= useState("")
  const [selectedStatus,setSelectedStatus]= useState("pending")
  const [toolTitle, setToolTitle]= useState("Create Duplicate")
  const [userID, setUserID]= useState("")
  const [materialType, setMaterialType]= useState("")
  const [allMaterials, setAllMaterials] = useState([]);
  const [materialData, setMaterialData]= useState([])
  const [approvalData, setApprovalData]= useState([])
  const [lastApprover, setLastApprover]= useState([])
  const [rawVendor,setRawVendor]= useState(null);
  const [allApproverDetails, setAllApproveDetails]= useState([])
  const [copiedMaterial,setCopiedMaterial]= useState({});
    const [isMsme, setIsMsme] = useState(false);
    const [isfssi, setIsFssi] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [selectedMaterial, setSelectedMaterial] = useState(null);
    const [currentPage, setCurrentPage]= useState(1);
    const [totalPages, setTotalPages]= useState(1);
    const [kdsdata,setKdsData]= useState({});
    const [allAuditLogs,setAllAuditLogs]= useState([])
    const capitalizeHeader = (header) => {
        return header
          .replace(/([A-Z])/g, ' $1') // Add space before capital letters
          .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
      };
      
      // useEffect(() => {
      //   setPage(currentPage); // Send currentPage to API handler
      // }, [currentPage, setPage]);

      const handlePageChange = (page) => {
        setCurrentPage(page);
      };
    const [allvalues, setAllValues] = useState({
        ASSET: {
          "Material Name": "",
          "Product Group Description": "",
          "UOM": "",
          "Approval_Status": "",
          "HSN Code": "",
          "Plant": ""
        },
        STORE: {
          "Material Name": "",
          "Product Group Description": "",
          "UOM": "",
          "Approval_Status": "",
          "HSN Code": "",
          "Plant": "",
          "Profit Center": "",
          "Valuation Class": ""
        },
        BROKEN_SCRAP: {
          "Material Name": "",
          "Product Group Description": "",
          "UOM": "",
          "Approval_Status": "",
          "HSN Code": "",
          "Plant": "",
          "Profit Center": "",
          "Valuation Class": ""
        },
        NON_VALUATED: {
          "Material Name": "",
          "Product Group Description": "",
          "UOM": "",
          "Approval_Status": "",
          "HSN Code": "",
          "Plant": "",
          "Profit Center": "",
          "Valuation Class": ""
        },
        FREE_GOODS: {
          "Material Name": "",
          "Product Group Description": "",
          "UOM": "",
          "Approval_Status": "",
          "HSN Code": "",
          "Plant": "",
          "Profit Center": "",
          "Valuation Class": ""
        },
        RGP: {
          "Material Name": "",
          "Product Group Description": "",
          "UOM": "",
          "Approval_Status": "",
          "HSN Code": "",
          "Plant": ""
        },
        RM:{
          "Material Name": "",
          "Product Group Description": "",
          "UOM": "",
          "Approval Status": "",
          "HSN Code": "",
          "Plant": "",
          "GST %": "",
          "Vendor State": "",
          "LENGTH (mm)": "",
          "WIDTH (mm)": "",
          "HEIGHT (mm)": "",
          "VOLUME(CBM)": "",
          "LEAD TIME (in days)": "",
          "MINIMUM STOCK (in days)": "",
          "MAXIMUM STOCK (in days)": ""
        },
        PM:{
          "Material Name": "",
          "Product Group Description": "",
          "UOM": "",
          "Approval_Status": "",
          "HSN Code": "",
          "Plant": "",
          "GST %": "",
          "Vendor State": "",
          "LENGTH (mm)": "",
          "WIDTH (mm)": "",
          "HEIGHT (mm)": "",
          "VOLUME(CBM)": "",
          "LEAD TIME (in days)": "",
          "MINIMUM STOCK (in days)": "",
          "MAXIMUM STOCK (in days)": ""
        },
        SFG:{
          "Material Name": "",
          "Product Group Description": "",
          "UOM": "",
          "Approval_Status": "",
          "HSN Code": "",
          "Plant": "",
          "GST %": "",
          "Vendor State": "",
          "LENGTH (mm)": "",
          "WIDTH (mm)": "",
          "HEIGHT (mm)": "",
          "VOLUME(CBM)": "",
          "LEAD TIME (in days)": "",
          "MINIMUM STOCK (in days)": "",
          "MAXIMUM STOCK (in days)": ""
        },
        FG: {
          "Product Brand Name": "",
          "Product Description": "",
          "Upper Unit (UOM)": "",
          "Approval_Status": "",
          "Code": "",
          "Status": "",
          "Manufacturing Plant": "",
          "Flavours": "",
          "Brand": "",
          "Product Segment": "",
          "Product Category": "",
          "Sub Category": "",
          "Pack Weight (g)": "",
          "Pack Format (No of packets in one carton)": "",
          "MRP. (INCL. OF ALL TAXES)": "",
          "Basic/Lowest Unit (UOM)": "",
          "1CB=Kgs": "",
          "MRP/CB": "",
          "Length(MM)": "",
          "Width(MM)": "",
          "Height(MM)": "",
          "Gross weight(kg)": "",
          "Volume (cbM)": "",
          "No of Biscuits in 1 packet": "",
          "Trade Point": "",
          "Packing Pattern": "",
          "Secondary Pack": "",
          "Type of Secondary Pack": "",
          "Integration with DMS": "",
          "Remarks": "",
          "Shelf Life": "",
          "BAR CODE/EAN NUMBER": "",
          "Min Stock in Days": "",
          "Lead Time In Days": "",
          "Max Stock in Days": "",
          "Availability check": "",
          "Trans Group": "",
          "Loading Group": "",
          "Profit Center": "",
          "Valuation Class": ""
        }
      });


      const fetchAllMaterialKDS=async()=>{
        try{
          const response= await fetchKDSMaterial();
          const res= response.data;
          if(res.status){
            setKdsData(res.data);
            console.log("kds fetched>> ", res.data);
          }else{
            console.log("could not bring vendor kds>> ", res)
          }
        }catch(error){
          console.log("error bringing material KDS>> ", error);
        }
      }

      const fetchAllMaterialLogs=async(matid)=>{
        const body={
          modulename: "Material",
          recordid: matid
        }
        console.log("log body>> ", body)
        try{
          const response= await fetchAuditLog(body);
          const res= response.data;
          if(res.status){
            setAllAuditLogs(res.data);
            console.log("logs fetched>> ", res.data);
          }else{
            console.log("could not bring material logs>> ", res)
          }
        }catch(error){
          console.log("error bringing material logs>> ", error);
        }
      }

      const fetchOneMaterial=async(matid)=>{
        setIsActive(true)
        const body={
          reference_id: matid
        }
        console.log("log body>> ", body)
        try{
          const response= await fetchSingleMaterial(body);
          const res= response.data;
          if(res.status){
            setCopiedMaterial(res.data);
            setIsActive(false)
            console.log("one mat fetched>> ", res.data);
          }else{
            setIsActive(false)
            console.log("could not bring material single>> ", res)
          }
        }catch(error){
          setIsActive(false)
          console.log("error bringing material single>> ", error);
        }
      }



      const [approvalFields, setApprovalFields] = useState({
        ASSET: [
          { name: "Material Code", type: "text", value: ""},
          { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}]},
          { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
          { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
          { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
          { name: "Brand", type: "dropdown", apiKey: "brand", option: [{}] },
          { name: "Brand Flavour", type: "dropdown", apiKey: "brndflvr", option: [{}] },
          { name: "Product Brand", type: "dropdown", apiKey: "prdbrand", option: [{}] },
          { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
          { name: "Standard Price", type: "text", value: "" },
          { name: "Gross Weight", type: "text", value: "" },
          { name: "Net Weight", type: "text", value: "" },
          { name: "Volume", type: "text", value: "" },
          { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] },
          { name: "Volume Unit", type: "dropdown", apiKey: "matuom", option: [{}]},
          { name: "Weight Unit", type: "text",  value: "KG" },
          { name: "Max Stock Level", type: "number", value: "" },
          { name: "Batch Management", type: "checkbox", value: '' },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
          { name: "Automatic PO", type: "checkbox", value: '' },
          { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          { name: "Tot repl lead time", type: "text", value: "" },
          { name: "Max Storage Period", type: "number", value: "" },
          { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
          { name: "Total shelf life", type: "text", value: "" },
          { name: "Min Rem Shelf Life", type: "text", value: "" },
        ],
        STORE: [
          { name: "Material Code", type: "text", value: ""},
          { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}]},
          { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
          { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
          { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
          { name: "Brand", type: "dropdown", apiKey: "brand", option: [{}] },
          { name: "Brand Flavour", type: "dropdown", apiKey: "brndflvr", option: [{}] },
          { name: "Product Brand", type: "dropdown", apiKey: "prdbrand", option: [{}] },
          { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
          { name: "Standard Price", type: "text", value: "" },
          { name: "Gross Weight", type: "text", value: "" },
          { name: "Net Weight", type: "text", value: "" },
          { name: "Volume", type: "text", value: "" },
          { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] },
          { name: "Volume Unit", type: "dropdown", apiKey: "matuom", option: [{}]},
          { name: "Weight Unit", type: "text",  value: "KG" },
          { name: "Max Stock Level", type: "number", value: "" },
          { name: "Batch Management", type: "checkbox", value: '' },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
          { name: "Automatic PO", type: "checkbox", value: '' },
          { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          { name: "Tot repl lead time", type: "text", value: "" },
          { name: "Max Storage Period", type: "number", value: "" },
          { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
          { name: "Total shelf life", type: "text", value: "" },
          { name: "Min Rem Shelf Life", type: "text", value: "" },
        ],
        BROKEN_SCRAP: [
          { name: "Material Code", type: "text", value: ""},
          { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}]},
          { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
          { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
          { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
          { name: "Brand", type: "dropdown", apiKey: "brand", option: [{}] },
          { name: "Brand Flavour", type: "dropdown", apiKey: "brndflvr", option: [{}] },
          { name: "Product Brand", type: "dropdown", apiKey: "prdbrand", option: [{}] },
          { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
          { name: "Standard Price", type: "text", value: "" },
          { name: "Gross Weight", type: "text", value: "" },
          { name: "Net Weight", type: "text", value: "" },
          { name: "Volume", type: "text", value: "" },
          { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] },
          { name: "Volume Unit", type: "dropdown", apiKey: "matuom", option: [{}]},
          { name: "Weight Unit", type: "text",  value: "KG" },
          { name: "Max Stock Level", type: "number", value: "" },
          { name: "Batch Management", type: "checkbox", value: '' },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
          { name: "Automatic PO", type: "checkbox", value: '' },
          { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          { name: "Tot repl lead time", type: "text", value: "" },
          { name: "Max Storage Period", type: "number", value: "" },
          { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
          { name: "Total shelf life", type: "text", value: "" },
          { name: "Min Rem Shelf Life", type: "text", value: "" },
        ],
        NON_VALUATED: [
          { name: "Material Code", type: "text", value: ""},
          { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}]},
          { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
          { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
          { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
          { name: "Brand", type: "dropdown", apiKey: "brand", option: [{}] },
          { name: "Brand Flavour", type: "dropdown", apiKey: "brndflvr", option: [{}] },
          { name: "Product Brand", type: "dropdown", apiKey: "prdbrand", option: [{}] },
          { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
          { name: "Standard Price", type: "text", value: "" },
          { name: "Gross Weight", type: "text", value: "" },
          { name: "Net Weight", type: "text", value: "" },
          { name: "Volume", type: "text", value: "" },
          { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] },
          { name: "Volume Unit", type: "dropdown", apiKey: "matuom", option: [{}]},
          { name: "Weight Unit", type: "text",  value: "KG" },
          { name: "Max Stock Level", type: "number", value: "" },
          { name: "Batch Management", type: "checkbox", value: '' },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
          { name: "Automatic PO", type: "checkbox", value: '' },
          { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          { name: "Tot repl lead time", type: "text", value: "" },
          { name: "Max Storage Period", type: "number", value: "" },
          { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
          { name: "Total shelf life", type: "text", value: "" },
          { name: "Min Rem Shelf Life", type: "text", value: "" },
        ],
        FREE_GOODS: [
          { name: "Material Code", type: "text", value: ""},
          { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}]},
          { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
          { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
          { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
          { name: "Brand", type: "dropdown", apiKey: "brand", option: [{}] },
          { name: "Brand Flavour", type: "dropdown", apiKey: "brndflvr", option: [{}] },
          { name: "Product Brand", type: "dropdown", apiKey: "prdbrand", option: [{}] },
          { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
          { name: "Standard Price", type: "text", value: "" },
          { name: "Gross Weight", type: "text", value: "" },
          { name: "Net Weight", type: "text", value: "" },
          { name: "Volume", type: "text", value: "" },
          { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] },
          { name: "Volume Unit", type: "dropdown", apiKey: "matuom", option: [{}]},
          { name: "Weight Unit", type: "text",  value: "KG" },
          { name: "Max Stock Level", type: "number", value: "" },
          { name: "Batch Management", type: "checkbox", value: '' },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
          { name: "Automatic PO", type: "checkbox", value: '' },
          { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          { name: "Tot repl lead time", type: "text", value: "" },
          { name: "Max Storage Period", type: "number", value: "" },
          { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
          { name: "Total shelf life", type: "text", value: "" },
          { name: "Min Rem Shelf Life", type: "text", value: "" },
        ],
        RGP: [
          { name: "Material Code", type: "text", value: ""},
          { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}]},
          { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
          { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
          { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
          { name: "Brand", type: "dropdown", apiKey: "brand", option: [{}] },
          { name: "Brand Flavour", type: "dropdown", apiKey: "brndflvr", option: [{}] },
          { name: "Product Brand", type: "dropdown", apiKey: "prdbrand", option: [{}] },
          { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
          { name: "Standard Price", type: "text", value: "" },
          { name: "Gross Weight", type: "text", value: "" },
          { name: "Net Weight", type: "text", value: "" },
          { name: "Volume", type: "text", value: "" },
          { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] },
          { name: "Volume Unit", type: "dropdown", apiKey: "matuom", option: [{}]},
          { name: "Weight Unit", type: "text",  value: "KG" },
          { name: "Max Stock Level", type: "number", value: "" },
          { name: "Batch Management", type: "checkbox", value: '' },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
          { name: "Automatic PO", type: "checkbox", value: '' },
          { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          { name: "Tot repl lead time", type: "text", value: "" },
          { name: "Max Storage Period", type: "number", value: "" },
          { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
          { name: "Total shelf life", type: "text", value: "" },
          { name: "Min Rem Shelf Life", type: "text", value: "" },],

        RM: [
          { name: "Material Code", type: "text", value: ""},
          { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}]},
          { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
          { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
          { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
          { name: "Brand", type: "dropdown", apiKey: "brand", option: [{}] },
          { name: "Brand Flavour", type: "dropdown", apiKey: "brndflvr", option: [{}] },
          { name: "Product Brand", type: "dropdown", apiKey: "prdbrand", option: [{}] },
          { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
          { name: "Standard Price", type: "text", value: "" },
          { name: "Gross Weight", type: "text", value: "" },
          { name: "Net Weight", type: "text", value: "" },
          { name: "Volume", type: "text", value: "" },
          { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] },
          { name: "Volume Unit", type: "dropdown", apiKey: "matuom", option: [{}]},
          { name: "Weight Unit", type: "text",  value: "KG" },
          { name: "Max Stock Level", type: "number", value: "" },
          { name: "Batch Management", type: "checkbox", value: '' },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
          { name: "Automatic PO", type: "checkbox", value: '' },
          { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          { name: "Tot repl lead time", type: "text", value: "" },
          { name: "Max Storage Period", type: "number", value: "" },
          { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
          { name: "Total shelf life", type: "text", value: "" },
          { name: "Min Rem Shelf Life", type: "text", value: "" },],

        PM: [
          { name: "Material Code", type: "text", value: ""},
          { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}]},
          { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
          { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
          { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
          { name: "Brand", type: "dropdown", apiKey: "brand", option: [{}] },
          { name: "Brand Flavour", type: "dropdown", apiKey: "brndflvr", option: [{}] },
          { name: "Product Brand", type: "dropdown", apiKey: "prdbrand", option: [{}] },
          { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
          { name: "Standard Price", type: "text", value: "" },
          { name: "Gross Weight", type: "text", value: "" },
          { name: "Net Weight", type: "text", value: "" },
          { name: "Volume", type: "text", value: "" },
          { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] },
          { name: "Volume Unit", type: "dropdown", apiKey: "matuom", option: [{}]},
          { name: "Weight Unit", type: "text",  value: "KG" },
          { name: "Max Stock Level", type: "number", value: "" },
          { name: "Batch Management", type: "checkbox", value: '' },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
          { name: "Automatic PO", type: "checkbox", value: '' },
          { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          { name: "Tot repl lead time", type: "text", value: "" },
          { name: "Max Storage Period", type: "number", value: "" },
          { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
          { name: "Total shelf life", type: "text", value: "" },
          { name: "Min Rem Shelf Life", type: "text", value: "" },],

        SFG: [
          { name: "Material Code", type: "text", value: ""},
          { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}]},
          { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
          { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
          { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
          { name: "Brand", type: "dropdown", apiKey: "brand", option: [{}] },
          { name: "Brand Flavour", type: "dropdown", apiKey: "brndflvr", option: [{}] },
          { name: "Product Brand", type: "dropdown", apiKey: "prdbrand", option: [{}] },
          { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
          { name: "Standard Price", type: "text", value: "" },
          { name: "Gross Weight", type: "text", value: "" },
          { name: "Net Weight", type: "text", value: "" },
          { name: "Volume", type: "text", value: "" },
          { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] },
          { name: "Volume Unit", type: "dropdown", apiKey: "matuom", option: [{}]},
          { name: "Weight Unit", type: "text",  value: "KG" },
          { name: "Max Stock Level", type: "number", value: "" },
          { name: "Batch Management", type: "checkbox", value: '' },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
          { name: "Automatic PO", type: "checkbox", value: '' },
          { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "In House Production", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          { name: "Tot repl lead time", type: "text", value: "" },
          { name: "Max Storage Period", type: "number", value: "" },
          { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
          { name: "Total shelf life", type: "text", value: "" },
          { name: "Min Rem Shelf Life", type: "text", value: "" },],

        FG:[
          { name: "Material Code", type: "text", value: ""},
          { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}]},
          { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
          { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
          { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
          { name: "Brand", type: "dropdown", apiKey: "brand", option: [{}] },
          { name: "Brand Flavour", type: "dropdown", apiKey: "brndflvr", option: [{}] },
          { name: "Product Brand", type: "dropdown", apiKey: "prdbrand", option: [{}] },
          { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
          { name: "Standard Price", type: "text", value: "" },
          { name: "Gross Weight", type: "text", value: "" },
          { name: "Net Weight", type: "text", value: "" },
          { name: "Volume", type: "text", value: "" },
          { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] },
          { name: "Volume Unit", type: "dropdown", apiKey: "matuom", option: [{}]},
          { name: "Weight Unit", type: "text",  value: "KG" },
          { name: "Max Stock Level", type: "number", value: "" },
          { name: "Batch Management", type: "checkbox", value: '' },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
          { name: "Automatic PO", type: "checkbox", value: '' },
          { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "In House Production", type: "text", value: "" },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          { name: "Tot repl lead time", type: "text", value: "" },
          { name: "Max Storage Period", type: "number", value: "" },
          { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
          { name: "Total shelf life", type: "text", value: "" },
          { name: "Min Rem Shelf Life", type: "text", value: "" },]
      });


      const [approvalFields2, setApprovalFields2] = useState({
        ASSET: {
          "Basic Data": [
            { name: "Material Code", type: "text", value: "" },
            { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}] },
            { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
            { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] , defaultVal:"NORM"},
            { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
            { name: "Gross Weight", type: "text", value: "1.00" },
            { name: "Net Weight", type: "text", value: "1.00" },
            { name: "Volume", type: "text", value: "0.00" },
            { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}], defaultVal:"SS00" },
            { name: "Weight Unit", type: "dropdown", apiKey: "matuom", option: [{}] },
          ],
          "Plant/ Storage Data": [
            { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          ],
          "Purchasing": [
            { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
            { name: "Automatic PO", type: "checkbox", value: '' },
          ],
          "Accounting": [
            { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}], defaultVal:"4080" },
            { name: "Standard Price", type: "text", value: "" },
          ]
        },
        STORE: {
          "Basic Data": [
            { name: "Material Code", type: "text", value: "" },
            { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}] },
            { name: "Division", type: "dropdown", apiKey: "division", option: [{}] ,defaultVal:"00"},
            { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}], defaultVal:"NORM" },
            { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
            { name: "Gross Weight", type: "text", value: "1.00" },
            { name: "Net Weight", type: "text", value: "1.00" },
            { name: "Volume", type: "text", value: "0.00" },
            { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] , defaultVal:"SS00"},
            { name: "Weight Unit", type: "text", value:"KG"},
          ],
          "Sales: General/Plant": [
            { name: "Sales Organization", type: "dropdown", apiKey:"salesorg", option: [{}] },
            { name: "Distribution Channel", type: "dropdown", apiKey:"distchnl", option: [{}] ,defaultVal:"DM"},
            { name: "Sales Unit", type: "dropdown",apiKey: "matuom", option: [{}] },
            { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
            { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] ,defaultVal:"0001"},
            { name: "Loading Group", type: "text", value: "",defaultVal:"0001" },
            { name: "Material Statistics Group", type: "dropdown",apiKey:"matstatgrp", option: [{}] },
            { name: "Material Price Group", type: "dropdown",apiKey:"matpricgrp", option: [{}] },
            { name: "Account Assignment Group Material", type: "dropdown", apiKey:"matacntasgnmnt", option: [{}] },
            { name: "Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] ,defaultVal:"NORM"},
          ],
          "Purchasing": [
            { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] , defaultVal:"PG5"},
            { name: "Batch Management", type: "checkbox", value: '' },
            { name: "Automatic PO", type: "checkbox", value: '' },
          ],
          "Accounting": [
            { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
            { name: "Standard Price", type: "text", value: "" },
          ]
        },
        BROKEN_SCRAP: {
          "Basic Data": [
            { name: "Material Code", type: "text", value: "" },
            { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}] },
            { name: "Division", type: "dropdown", apiKey: "division", option: [{}] ,defaultVal:"00"},
            { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] , defaultVal:"NORM"},
            { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
            { name: "Gross Weight", type: "text", value: "1.00" },
            { name: "Net Weight", type: "text", value: "1.00" },
            { name: "Volume", type: "text", value: "0.00" },
            { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}], defaultVal:"SCRP" },
            { name: "Weight Unit", type: "text", value:"KG"},
          ],
          "Sales: General/Plant": [
            { name: "Sales Organization", type: "dropdown", apiKey:"salesorg", option: [{}] },
            { name: "Distribution Channel", type: "dropdown", apiKey:"distchnl", option: [{}] ,defaultVal:"DM"},
            { name: "Sales Unit", type: "dropdown",apiKey: "matuom", option: [{}] },
            { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
            { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}],defaultVal:"0001" },
            { name: "Loading Group", type: "text", value: "" ,defaultVal:"0001"},
            { name: "Material Statistics Group", type: "dropdown",apiKey:"matstatgrp", option: [{}] },
            { name: "Material Price Group", type: "dropdown",apiKey:"matpricgrp", option: [{}] },
            { name: "Account Assignment Group Material", type: "dropdown", apiKey:"matacntasgnmnt", option: [{}] },
            { name: "Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] ,defaultVal:"NORM"},
          ],
          "Purchasing": [
            { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
            { name: "Batch Management", type: "checkbox", value: '' },
            { name: "Automatic PO", type: "checkbox", value: '' },
          ],
          "Accounting": [
            { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}], defaultVal:"8002" },
            { name: "Standard Price", type: "text", value: "" },
          ]
        },
        NON_VALUATED: {
          "Basic Data": [
            { name: "Material Code", type: "text", value: "" },
            { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}] },
            { name: "Division", type: "dropdown", apiKey: "division", option: [{}] ,defaultVal:"00"},
            { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] ,defaultVal:"NORM"},
            { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
            { name: "Gross Weight", type: "text", value: "1.00" },
            { name: "Net Weight", type: "text", value: "1.00" },
            { name: "Volume", type: "text", value: "0.00" },
            { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}], defaultVal:"TRD0" },
            { name: "Weight Unit", type: "text", value:"KG"},
          ],
          "Plant Data/Storage": [
            { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          ],
          "Purchasing": [
            { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
            { name: "Batch Management", type: "checkbox", value: '' },
            { name: "Automatic PO", type: "checkbox", value: '' },
          ],
          "Material Requirement Planning": [
            { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Schedule Margin Key", type: "dropdown", apiKey: "marginkey", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          ],
        },
        FREE_GOODS: {
          "Basic Data": [
            { name: "Material Code", type: "text", value: "" },
            { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}] },
            { name: "Division", type: "dropdown", apiKey: "division", option: [{}] ,defaultVal:"00"},
            { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}], defaultVal:"ZNRM" },
            { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
            { name: "Gross Weight", type: "text", value: "1.00" },
            { name: "Net Weight", type: "text", value: "1.00" },
            { name: "Volume", type: "text", value: "0.00" },
            { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}], defaultVal:"SC00" },
            { name: "Weight Unit", type: "text", value:"KG"},
          ],
          "Sales: General/Plant": [
            { name: "Sales Organization", type: "dropdown", apiKey:"salesorg", option: [{}] },
            { name: "Distribution Channel", type: "dropdown", apiKey:"distchnl", option: [{}] ,defaultVal:"DM"},
            { name: "Sales Unit", type: "dropdown",apiKey: "matuom", option: [{}] },
            { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
            { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] ,defaultVal:"0001"},
            { name: "Loading Group", type: "text", value: "",defaultVal:"0001" },
            { name: "Material Statistics Group", type: "dropdown",apiKey:"matstatgrp", option: [{}] },
            { name: "Material Price Group", type: "dropdown",apiKey:"matpricgrp", option: [{}] },
            { name: "Account Assignment Group Material", type: "dropdown", apiKey:"matacntasgnmnt", option: [{}] },
            { name: "Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] ,defaultVal:"ZNRM"},
          ],
          "Purchasing": [
            { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] , defaultVal:"PG4"},
            { name: "Batch Management", type: "checkbox", value: '' },
            { name: "Automatic PO", type: "checkbox", value: '' },
          ],
          "Accounting": [
            { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
            { name: "Standard Price", type: "text", value: "" },
          ],
          "Material Requirement Planning": [
            { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Schedule Margin Key", type: "dropdown", apiKey: "marginkey", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          ],
        },
        RGP: {
          "Basic Data": [
            { name: "Material Code", type: "text", value: "" },
            { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}] },
            { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
            { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
            { name: "Gross Weight", type: "text", value: "1.00" },
            { name: "Net Weight", type: "text", value: "1.00" },
            { name: "Volume", type: "text", value: "0.00" },
            { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}], defaultVal:"SS00" },
            { name: "Weight Unit", type: "text", value: "KG" },
          ],
          "Plant/ Storage Data": [
            { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
          ],
          "Purchasing": [
            { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] ,defaultVal:"RGP"},
            { name: "Automatic PO", type: "checkbox", value: '' },
          ],
        },
        RM: {
          "Basic Data": [
            { name: "Material Code", type: "text", value: "" },
            { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}] },
            { name: "Division", type: "dropdown", apiKey: "division", option: [{}] ,defaultVal:"00"},
            { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] , defaultVal:"NORM"},
            { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
            { name: "Gross Weight", type: "text", value: "1.00" },
            { name: "Net Weight", type: "text", value: "1.00" },
            { name: "Volume", type: "text", value: "0.00" },
            { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}], defaultVal:"RM00" },
            { name: "Weight Unit", type: "text", value:"KG"},
          ],
          "Sales: General/Plant": [
            { name: "Sales Organization", type: "dropdown", apiKey:"salesorg", option: [{}] },
            { name: "Distribution Channel", type: "dropdown", apiKey:"distchnl", option: [{}] ,defaultVal:"DM"},
            { name: "Sales Unit", type: "dropdown",apiKey: "matuom", option: [{}] },
            { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
            { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
            { name: "Loading Group", type: "text", value: "",defaultVal:"0001" },
            { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
            { name: "Material Statistics Group", type: "dropdown",apiKey:"matstatgrp", option: [{}] },
            { name: "Material Price Group", type: "dropdown",apiKey:"matpricgrp", option: [{}] },
            { name: "Account Assignment Group Material", type: "dropdown", apiKey:"matacntasgnmnt", option: [{}] },
            { name: "Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] ,defaultVal:"NORM"},
          ],
          "Purchasing": [
            { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] },
            { name: "Batch Management", type: "checkbox", value: '' },
            { name: "Automatic PO", type: "checkbox", value: '' },
          ],
          "Material Requirement Planning": [
            { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}],defaultVal:"PD" },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Schedule Margin Key", type: "dropdown", apiKey: "marginkey", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}],defaultVal:"0000" },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          ],
          "Plant Data/ Storage":[
            { name: "Tot repl lead time", type: "text", value: "" },
            { name: "Max Storage Period", type: "number", value: "" },
            { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
            { name: "Total shelf life", type: "text", value: "" },
            { name: "Min Rem Shelf Life", type: "text", value: "" },
          ],
          "Accounting": [
            { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
            { name: "Standard Price", type: "text", value: "" },
          ]
        },
        PM: {
          "Basic Data": [
            { name: "Material Code", type: "text", value: "" },
            { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}] },
            { name: "Division", type: "dropdown", apiKey: "division", option: [{}] ,defaultVal:"00"},
            { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] , defaultVal:"NORM"},
            { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
            { name: "Gross Weight", type: "text", value: "1.00" },
            { name: "Net Weight", type: "text", value: "1.00" },
            { name: "Volume", type: "text", value: "0.00" },
            { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] , defaultVal:"PK00"},
            { name: "Weight Unit", type: "text", value:"KG"},
          ],
          "Sales: General/Plant": [
            { name: "Sales Organization", type: "dropdown", apiKey:"salesorg", option: [{}] },
            { name: "Distribution Channel", type: "dropdown", apiKey:"distchnl", option: [{}] ,defaultVal:"DM"},
            { name: "Sales Unit", type: "dropdown",apiKey: "matuom", option: [{}] },
            { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
            { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
            { name: "Loading Group", type: "text", value: "",defaultVal:"0001" },
            { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
            { name: "Material Statistics Group", type: "dropdown",apiKey:"matstatgrp", option: [{}] },
            { name: "Material Price Group", type: "dropdown",apiKey:"matpricgrp", option: [{}] },
            { name: "Account Assignment Group Material", type: "dropdown", apiKey:"matacntasgnmnt", option: [{}] },
            { name: "Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] ,defaultVal:"NORM"},
          ],
          "Purchasing": [
            { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] ,defaultVal:"PG7"},
            { name: "Batch Management", type: "checkbox", value: '' },
            { name: "Automatic PO", type: "checkbox", value: '' },
          ],
          "Material Requirement Planning": [
            { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] ,defaultVal:"PD"},
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Schedule Margin Key", type: "dropdown", apiKey: "marginkey", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}],defaultVal:"0000" },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          ],
          "Plant Data/ Storage":[
            { name: "Tot repl lead time", type: "text", value: "" },
            { name: "Max Storage Period", type: "number", value: "" },
            { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
            { name: "Total shelf life", type: "text", value: "" },
            { name: "Min Rem Shelf Life", type: "text", value: "" },
          ],
          "Accounting": [
            { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
            { name: "Standard Price", type: "text", value: "" },
          ]
        },
        SFG: {
          "Basic Data": [
            { name: "Material Code", type: "text", value: "" },
            { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}] },
            { name: "Division", type: "dropdown", apiKey: "division", option: [{}] },
            { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
            { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
            { name: "Gross Weight", type: "text", value: "1.00" },
            { name: "Net Weight", type: "text", value: "1.00" },
            { name: "Volume", type: "text", value: "0.00" },
            { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}] },
            { name: "Weight Unit", type: "text", value:"KG" },
          ],
          "Sales: General/Plant": [
            { name: "Sales Organization", type: "dropdown", apiKey:"salesorg", option: [{}] },
            { name: "Distribution Channel", type: "dropdown", apiKey:"distchnl", option: [{}] },
            { name: "Sales Unit", type: "dropdown",apiKey: "matuom", option: [{}] },
            { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
            { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
            { name: "Trans Group", type: "dropdown", apiKey: "transgrp", option: [{}] },
            { name: "Loading Group", type: "text", value: "" },
            { name: "Material Statistics Group", type: "dropdown",apiKey:"matstatgrp", option: [{}] },
            { name: "Material Price Group", type: "dropdown",apiKey:"matpricgrp", option: [{}] },
            { name: "Account Assignment Group Material", type: "dropdown", apiKey:"matacntasgnmnt", option: [{}] },
            { name: "Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] },
          ],
          "Purchasing": [
            { name: "Batch Management", type: "checkbox", value: '' },
            { name: "Automatic PO", type: "checkbox", value: '' },
          ],
          "Material Requirement Planning": [
            { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}] },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Schedule Margin Key", type: "dropdown", apiKey: "marginkey", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}] },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "In House Production", type: "text",  value: "" },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          ],
          "Plant Data/ Storage":[
            { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
            { name: "Tot repl lead time", type: "text", value: "" },
            { name: "Max Storage Period", type: "number", value: "" },
            { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
            { name: "Min Rem Shelf Life", type: "text", value: "" },
          ],
          "Accounting": [
            { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}] },
            { name: "Standard Price", type: "text", value: "" },
          ]
        },
        FG: {
          "Basic Data": [
            { name: "Material Code", type: "text", value: "" },
            { name: "Product Brand", type: "dropdown", apiKey: "prdbrand", option: [{}] },
            { name: "Mat Type", type: "dropdown", apiKey: "mattype", option: [{}] },
            { name: "Division", type: "dropdown", apiKey: "division", option: [{}] ,defaultVal:"00"},
            { name: "General Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}], defaultVal:"NORM" },
            { name: "Mat Grp", type: "dropdown", apiKey: "matgrp", option: [{}] },
            { name: "Gross Weight", type: "text", value: "" },
            { name: "Net Weight", type: "text", value: "" },
            { name: "Volume", type: "text", value: "" },
            { name: "Storage Location", type: "dropdown",apiKey: "storgloc", option: [{}], defaultVal:"MFG0" },
            { name: "Weight Unit", type: "text", value:"KG" },
            { name: "Brand", type: "dropdown", apiKey: "brand", option: [{}] },
            { name: "Brand Flavour", type: "dropdown", apiKey: "brndflvr", option: [{}] },
          ],
          "Sales: General/Plant": [
            { name: "Sales Organization", type: "dropdown", apiKey:"salesorg", option: [{}] },
            { name: "Distribution Channel", type: "dropdown", apiKey:"distchnl", option: [{}] ,defaultVal:"DM"},
            { name: "Sales Unit", type: "dropdown",apiKey: "matuom", option: [{}] },
            { name: "Trans group", type: "dropdown", apiKey: "transgrp", option: [{}] },
            { name: "Loading group", type: "text", value: "" ,defaultVal:"0001"},
            { name: "Profit Center", type: "dropdown", apiKey: "prftcntr", option: [{}] },
            { name: "Material Statistics Group", type: "dropdown",apiKey:"matstatgrp", option: [{}] },
            { name: "Material Price Group", type: "dropdown",apiKey:"matpricgrp", option: [{}] },
            { name: "Account Assignment Group Material", type: "dropdown", apiKey:"matacntasgnmnt", option: [{}] },
            { name: "Item Category Group", type: "dropdown", apiKey: "itemcat", option: [{}] ,defaultVal:"NORM"},
          ],
          "Purchasing": [
            { name: "Purchasing Group", type: "dropdown", apiKey: "prchsgrp", option: [{}] ,defaultVal:"FG1"},
            { name: "Batch Management", type: "checkbox", value: '' },
            { name: "Automatic PO", type: "checkbox", value: '' },
          ],
          "Material Requirement Planning": [
            { name: "MRP Type", type: "dropdown", apiKey: "mrptyp", option: [{}],defaultVal:"PD" },
          { name: "MRP Controller", type: "dropdown", apiKey: "mrpcntrlr", option: [{}] },
          { name: "Schedule Margin Key", type: "dropdown", apiKey: "marginkey", option: [{}] },
          { name: "MRP Group", type: "dropdown", apiKey: "mrpgrp", option: [{}],defaultVal:"0000" },
          { name: "Lot Sizing Procedure", type: "dropdown", apiKey: "lotsize", option: [{}] },
          { name: "Procurement Type", type: "dropdown", apiKey: "procurement", option: [{}] },
          { name: "Backflush", type: "dropdown", apiKey: "backflush", option: [{}] },
          { name: "GR processing time", type: "text", value: "" },
          { name: "Planned Deliv Time", type: "text", value: "" },
          { name: "In House Production", type: "text",  value: "" },
          { name: "Strategy Group", type: "dropdown", apiKey: "strtggrp", option: [{}] },
          { name: "Consumption mode", type: "dropdown", apiKey: "consumpmode", option: [{}] },
          ],
          "Plant Data/ Storage":[
            { name: "Availability Check", type: "dropdown", apiKey: "avlcheck", option: [{}] },
            { name: "Tot repl lead time", type: "text", value: "" },
            { name: "Max Storage Period", type: "number", value: "" },
            { name: "Time unit", type: "dropdown", apiKey: "timeunit", option: [{}] },
            { name: "Min Rem Shelf Life", type: "text", value: "" },
          ],
          "Accounting": [
            { name: "Valuation Class", type: "dropdown", apiKey: "valclass", option: [{}], defaultVal:"5000" },
            { name: "Standard Price", type: "text", value: "" },
          ]
        },
      });

      const fieldDisplayNames = {
        material_id: "Material ID",
        material_code: "Material Code",
        material_name: "Material Name",
        belongs_to: "Belongs To",
        product_group_description: "Product Group Description",
        mat_grp: "Material Group",
        uom: "Unit of Measure",
        hsn_code: "HSN Code",
        approval_status: "Approval Status",
        plant: "Plant",
        extended_plant: "Extended Plant",
        material_type: "Material Type",
        material_status: "Material Status",
        gst_percentage: "GST Percentage",
        vendor_state: "Vendor State",
        length_mm: "Length (mm)",
        width_mm: "Width (mm)",
        height_mm: "Height (mm)",
        volume_cbm: "Volume (CBM)",
        lead_time_days: "Lead Time (Days)",
        minimum_stock_days: "Minimum Stock Days",
        maximum_stock_days: "Maximum Stock Days",
        sap_code: "SAP Code",
        created_by: "Created By",
        created_on: "Created On",
        product_segment: "Product Segment",
        pack_weight_g: "Pack Weight (g)",
        pack_format: "Pack Format",
        mrp: "MRP",
        basic_lowest_unit_uom: "Basic Lowest Unit UOM",
        one_cb_kgs: "One CB (kg)",
        mrp_cb: "MRP per CB",
        no_of_bisc_packet: "No. of Biscuits per Packet",
        trade_point: "Trade Point",
        packing_pattern: "Packing Pattern",
        secondary_pack_quantity: "Secondary Pack Quantity",
        type_of_secondary_pack: "Type of Secondary Pack",
        integration_with_dms: "Integrated with DMS",
        remarks: "Remarks",
        shelf_life: "Shelf Life",
        bar_code_ean_number: "Barcode (EAN)",
        min_stock_days: "Min Stock Days",
        max_stock_days: "Max Stock Days",
        availability_check: "Availability Check",
        trans_group: "Transport Group",
        loading_group: "Loading Group",
        valuation_class: "Valuation Class",
        standard_price: "Standard Price",
        gross_weight: "Gross Weight",
        net_weight: "Net Weight",
        volume: "Volume",
        general_item_category_group: "General Item Category Group",
        mat_type: "Material Type (ZFG)",
        purchasing_group: "Purchasing Group",
        profit_center: "Profit Center",
        division: "Division",
        weight_unit: "Weight Unit",
        volume_unit: "Volume Unit",
        gr_processing_time: "GR Processing Time",
        mrp_group: "MRP Group",
        mrp_type: "MRP Type",
        mrp_controller: "MRP Controller",
        automatic_po: "Automatic PO",
        batch_management: "Batch Management",
        max_stock_level: "Max Stock Level",
        in_house_production: "In-House Production",
        lot_sizing_procedure: "Lot Sizing Procedure",
        ext_matl_group: "External Material Group",
        brand: "Brand",
        product_category: "Product Category",
        brand_flavour: "Brand Flavour",
        sub_category: "Sub Category",
        product_brand: "Product Brand",
        pack_size: "Pack Size",
        procurement_type: "Procurement Type",
        special_procurement: "Special Procurement",
        backflush: "Backflush",
        planned_deliv_time: "Planned Delivery Time",
        strategy_group: "Strategy Group",
        consumption_mode: "Consumption Mode",
        tot_repl_lead_time: "Total Repl. Lead Time",
        max_storage_period: "Max Storage Period",
        total_shelf_life: "Total Shelf Life",
        time_unit: "Time Unit",
        min_rem_shelf_life: "Min Remaining Shelf Life",
        period_ind: "Period Indicator",
        storage_location: "Storage Location",
        copied_from: "Copied From",
        material_statistics_group: "Material Statistics Group",
        material_price_group: "Material Price Group",
        account_assignment_group_material: "Account Assignment Group",
        item_category_group: "Item Category Group",
        sales_unit: "Sales Unit",
        sales_organization: "Sales Organization",
        distribution_channel: "Distribution Channel",
        schedule_margin_key: "Schedule Margin Key",
        all_approver_details: "All Approver Details"
      };
      
      
      

      const kdsMapping = {
        "Division": "division",
        "General Item Category Group": "genItemCatGroup",
        "Material Group": "matgrp",
        "Purchasing Group": "prchsgrp",
        "Profit Center": "prftcntr",
        "Valuation Class": "valclass",
        "Weight Unit": "weightUnit",
      };


      const handleSearchChange = (e) => {
        const value = e.target.value;
        setMaterialSearch(value);
        latestSearchRef.current = value;
    
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    
       
    typingTimeoutRef.current = setTimeout(() => {
      fetchAllMaterials(); // Inside this function, access latest value from latestSearchRef.current
    }, 2000);
    
       
      };


      useEffect(() => {
        if (!selectedVendor) return;
      
        setApprovalFields((prevFields) => {
          const updateDefaultValues = (fields) => {
            return fields.map((field) => {
              const keyName = field.name.toLowerCase().replace(/ /g, "_");
              if (selectedVendor[keyName] !== undefined) {
                return { ...field, defaultVal: selectedVendor[keyName] };
              }
              return field;
            });
          };
      
          return {
            ASSET: updateDefaultValues(prevFields.ASSET),
            STORE: updateDefaultValues(prevFields.STORE),
            BROKEN_SCRAP: updateDefaultValues(prevFields.BROKEN_SCRAP),
            NON_VALUATED: updateDefaultValues(prevFields.NON_VALUATED),
            FREE_GOODS: updateDefaultValues(prevFields.FREE_GOODS),
            RGP: updateDefaultValues(prevFields.RGP),
            RM: updateDefaultValues(prevFields.RM),
            PM: updateDefaultValues(prevFields.PM),
            SFG: updateDefaultValues(prevFields.SFG),
            FG: updateDefaultValues(prevFields.FG),
          };
        });

       setApprovalFields2((prevFields) => {
  const updateDefaultValues = (fields, sectionName) => {
    const updated = Object.fromEntries(
      Object.entries(fields).map(([section, fieldArray]) => [
        section,
        Array.isArray(fieldArray)
          ? fieldArray.map((field) => {
              const keyName = field?.name.toLowerCase().replace(/ /g, "_");

              if (selectedVendor) {
                if (field.name === "Mat Type") {
                  return {
                    ...field,
                    defaultVal:
                      selectedVendor.product_group_description ??
                      field.defaultVal,
                  };
                }

                if (field.name === "Volume") {
                  return {
                    ...field,
                    defaultVal:
                      selectedVendor.volume_cbm ?? field.defaultVal,
                  };
                }

                // for others → only overwrite if not null/empty string
                if (
                  selectedVendor[keyName] !== undefined &&
                  selectedVendor[keyName] !== null &&
                  selectedVendor[keyName] !== ""
                ) {
                  return { ...field, defaultVal: selectedVendor[keyName] };
                }
              }

              // fallback: keep the original
              return { ...field, defaultVal: field.defaultVal };
            })
          : fieldArray
      ])
    );

    console.log(`Updated fields for ${sectionName}:`, updated);
    return updated;
  };

  const newState = {
    ASSET: updateDefaultValues(prevFields.ASSET || {}, "ASSET"),
    STORE: updateDefaultValues(prevFields.STORE || {}, "STORE"),
    BROKEN_SCRAP: updateDefaultValues(prevFields.BROKEN_SCRAP || {}, "BROKEN_SCRAP"),
    NON_VALUATED: updateDefaultValues(prevFields.NON_VALUATED || {}, "NON_VALUATED"),
    FREE_GOODS: updateDefaultValues(prevFields.FREE_GOODS || {}, "FREE_GOODS"),
    RGP: updateDefaultValues(prevFields.RGP || {}, "RGP"),
    RM: updateDefaultValues(prevFields.RM || {}, "RM"),
    PM: updateDefaultValues(prevFields.PM || {}, "PM"),
    SFG: updateDefaultValues(prevFields.SFG || {}, "SFG"),
    FG: updateDefaultValues(prevFields.FG || {}, "FG"),
  };

  console.log("Final approvalFields2 state >>>", newState);
  return newState;
});

        
      }, [selectedVendor]);

      useEffect(() => {
       setApprovalFields2((prevFields) => {
  const updateDefaultValues = (fields, sectionName) => {
    const updated = Object.fromEntries(
      Object.entries(fields).map(([section, fieldArray]) => [
        section,
        Array.isArray(fieldArray)
          ? fieldArray.map((field) => {
              const keyName = field?.name.toLowerCase().replace(/ /g, "_");

              if (copiedMaterial) {
                if (field.name === "Mat Type") {
                  return {
                    ...field,
                    defaultVal:
                      copiedMaterial.product_group_description ??
                      field.defaultVal,
                  };
                }

                if (field.name === "Volume") {
                  return {
                    ...field,
                    defaultVal:
                      copiedMaterial.volume_cbm ?? field.defaultVal,
                  };
                }

                // for others → only overwrite if not null/empty string
                if (
                  copiedMaterial[keyName] !== undefined &&
                  copiedMaterial[keyName] !== null &&
                  copiedMaterial[keyName] !== ""
                ) {
                  return { ...field, defaultVal: copiedMaterial[keyName] };
                }
              }

              // fallback: keep the original
              return { ...field, defaultVal: field.defaultVal };
            })
          : fieldArray
      ])
    );

    console.log(`Updated fields for ${sectionName}:`, updated);
    return updated;
  };

  const newState = {
    ASSET: updateDefaultValues(prevFields.ASSET || {}, "ASSET"),
    STORE: updateDefaultValues(prevFields.STORE || {}, "STORE"),
    BROKEN_SCRAP: updateDefaultValues(prevFields.BROKEN_SCRAP || {}, "BROKEN_SCRAP"),
    NON_VALUATED: updateDefaultValues(prevFields.NON_VALUATED || {}, "NON_VALUATED"),
    FREE_GOODS: updateDefaultValues(prevFields.FREE_GOODS || {}, "FREE_GOODS"),
    RGP: updateDefaultValues(prevFields.RGP || {}, "RGP"),
    RM: updateDefaultValues(prevFields.RM || {}, "RM"),
    PM: updateDefaultValues(prevFields.PM || {}, "PM"),
    SFG: updateDefaultValues(prevFields.SFG || {}, "SFG"),
    FG: updateDefaultValues(prevFields.FG || {}, "FG"),
  };

  console.log("Final approvalFields2 state >>>", newState);
  return newState;
});
      },[copiedMaterial])

      // useEffect(() => {
      //   if (!kdsdata) return;
      
      //   setApprovalFields(prevState => ({
      //     ASSET: prevState.ASSET.map(field => 
      //       kdsMapping[field.name] 
      //         ? { ...field, option: kdsdata[kdsMapping[field.name]] || [] } 
      //         : field
      //     )
      //   }));
      // }, [kdsdata]);
  


     

      const fetchAllMaterials=async(status)=>{
        setIsActive(true)

        let body;
        let myuser= JSON.parse(localStorage.getItem("userdetails"));
        let myID= myuser.id 
        if(status!=="" && status!==null && status!==undefined){
          body={
            material_type:"",
            page:1,
            limit:"10",
            material_status: status,
            search: latestSearchRef.current,
            userID:myID
          }
        }
        else{

          body={
            material_type: "",
            page: latestSearchRef.current==""? currentPage: 1,
            limit: "10",
            material_status: selectedStatus,
            search: latestSearchRef.current,
            userID:myID
          }
        } 

        console.log("body is>> ", body)

        try{
          const response= await fetchMaterials(body);
          const res= response.data;
          if(res.status){
            console.log("materials fetched>> ", res.data);
            setMaterialData(res.data);
            setCurrentPage(res.currentPage);
            setTotalPages(res.totalPages);
            setIsActive(false)
            // fetchAllPagesData();
          }else{
            console.log("Could not fetch materials>> ", res)
            setMaterialData([]);
            setTotalPages(1)
            setIsActive(false)
          }
        }catch(error){
          console.log("Error fetching the materials list>> ", error)
          setMaterialData([]);
          setTotalPages(1)
          if(error.response?.status==403){
            if(!toast.isActive(toastId.current)){
              toastId.current= toast.error("Your Session has expired",{
                className:"small-toast"
              })
            }
            setTimeout(()=>{
              navigate("/")
              localStorage.clear();
            },2000)
            return;
          }
          setIsActive(false)
        }
      }

      const fetchAllPagesData = async () => {
        setIsActive(true)
        let page = 1;
        let allData = [];
        let totalPages = 1;
      
        try {
          do {
            const body = {
              material_type: "",
              page,
              limit: "10"
            };
      
            const response = await fetchMaterials(body);
            const res = response.data;
      
            if (res.status) {
              allData = [...allData, ...res.data];
              totalPages = res.totalPages;
              page++;
            } else {
              break;
            }
          } while (page <= totalPages);
      
          setAllMaterials(allData);
          setIsActive(false)
          console.log("📦 All materials (all pages) >>", allData);
        } catch (err) {
          console.error("Failed to fetch all materials:", err);
          setIsActive(false)
        }
      };
      

      useEffect(()=>{
        fetchAllMaterialKDS();
        let savedMaterial= localStorage.getItem("materialSaved");
        let parsedMaterial= JSON.parse(savedMaterial);
        if(parsedMaterial){
          console.log("material is>> ", parsedMaterial)
          setAllValues(parsedMaterial)
        }

        const storedUser = JSON.parse(localStorage.getItem("userDetails"));
        const loggedinUser= JSON.parse(localStorage.getItem("userdetails"));
        let user_roleDetails= JSON.parse(localStorage.getItem("userRoles"));
    if(user_roleDetails){
     
      setApprovalAllowed(user_roleDetails[0].material_approval==1? true:false)
    }
        if (storedUser) {
          setUser(storedUser);
          console.log("storeduser is>> ", storedUser)
          setIsApp1(storedUser.level === "app-1");
          setIsApp2(storedUser.level === "app-2");
          setIsApp3(storedUser.level === "app-3");
        }
        if(loggedinUser){
          setUserID(loggedinUser.id)
        }
        fetchAllMaterials()
      },[currentPage])


      // if (isApp1 && materialStatus === "finalApproved") {
      //   return <Typography>Material Approved</Typography>;
      // }
      // if (isApp1 && materialStatus === "finalRejected") {
      //   return <Typography>Material Rejected</Typography>;
      // }
      // if (isApp2 && materialStatus === "initialRejected") {
      //   return <Typography>Rejected</Typography>;
      // }


      const fieldOptions = {
        ASSET: ["material_name", "product_group_description", "uom", "hsn_code", "plant", "belongs_to"],
        STORE: ["material_name", "product_group_description", "uom", "hsn_code", "plant"],
        BROKEN_SCRAP: ["material_name", "product_group_description", "uom", "hsn_code", "plant"],
        NON_VALUATED: ["material_name", "product_group_description", "uom", "hsn_code", "plant"],
        FREE_GOODS: ["material_name", "product_group_description", "uom", "hsn_code", "plant"],
        RGP: ["material_name", "product_group_description", "uom", "hsn_code", "plant"],
        RM: [
          "material_name", "product_group_description", "uom", "hsn_code", "plant", "gst_percent", "vendor_state",
          "length_mm", "width_mm", "height_mm", "volume_cbm", "lead_time_days", "minimum_stock_days", "maximum_stock_days"
        ],
        PM: [
          "material_name", "product_group_description", "uom", "hsn_code", "plant", "gst_percent", "vendor_state",
          "length_mm", "width_mm", "height_mm", "volume_cbm", "lead_time_days", "minimum_stock_days", "maximum_stock_days"
        ],
        SFG: [
          "material_name", "product_group_description", "uom", "hsn_code", "plant", "gst_percent", "vendor_state",
          "length_mm", "width_mm", "height_mm", "volume_cbm", "lead_time_days", "minimum_stock_days", "maximum_stock_days"
        ],
        FG: [
          "product_name", "product_segment", "pack_weight_g", "pack_format_no_of_packets_in_one_carton",
          "mrp_incl_of_all_taxes", "basic_lowest_unit_uom", "flavours", "one_cb_kgs", "mrp_cb",
          "length_mm", "width_mm", "height_mm", "volume_cbm", "no_of_biscuits_in_one_packet",
          "trade_point", "packing_pattern", "secondary_pack", "type_of_secondary_pack",
          "integration_with_dms", "remarks", "shelf_life", "bar_code_ean_number", "min_stock_days",
          "lead_time_days", "max_stock_days", "availability_check", "trans_group",
          "loading_group", "valuation_class"
        ]
      };
      


      const materialDetails = [
        {
          materialType: 'ASSET',
          materialName: 'XYZ Steel Rod',
          productGroupDescription: 'Metal Products',
          uom: 'KG',
          hsnCode: '7002567',
          plant: '2003 (Kolkata)',
        },
        {
          materialType: 'STORE',
          materialName: 'ABC Packaging Box',
          productGroupDescription: 'Packaging Materials',
          uom: 'KG',
          hsnCode: '5056567',
          plant: '1003 (Mumbai)',
          profitCenter: '3005 (Retail)',
          valuationClass: '3100 (Packaging Material)'
        },
        {
            materialType: 'RGP',
            materialName: 'BCD Nut Bolt',
            productGroupDescription: 'Metal Products',
            uom: 'KG',
            hsnCode: '450067',
            plant: '2003 (Kolkata)',
          },
          {
            materialType: "RM PM SFG",
            materialName: "XYZ Plastic Sheet",
            productGroupDescription: "Raw Materials - Plastics",
            uom: "M2",
            hsnCode: "39201090",
            plant: "3001 (Chennai)",
            gstPercentage: "18",
            vendorState: "Tamil Nadu",
            length: "2000",
            width: "1000",
            height: "5",
            volumeCBM: "0.01",
            leadTimeDays: "7",
            minimumStockDays: "15",
            maximumStockDays: "45"
          },
          {
            materialType: "FG",
            productBrandName: "ABC Biscuits",
            productDescription: "Crunchy chocolate-flavored biscuits",
            upperUnitUOM: "KG",
            status: "Active",
            manufacturingPlant: "5001 (Hyderabad)",
            code: "FG-12345",
            flavours: "Chocolate",
            brand: "ABC Foods",
            productSegment: "Snacks",
            productCategory: "Biscuits",
            subCategory: "Chocolate Biscuits",
            packWeight: "150",
            packFormat: "12",
            mrpInclTaxes: "120",
            basicLowestUOM: "G",
            
            oneCBKgs: "1.8",
            mrpPerCB: "180",
            lengthMM: "200",
            widthMM: "100",
            heightMM: "80",
            grossWeightKG: "2",
            volumeCBM: "0.016",
            noOfBiscuitsInPacket: "10",
            tradePoint: "Retail",
            packingPattern: "Shrink Wrap",
            secondaryPack: "Carton",
            typeOfSecondaryPack: "Corrugated Box",
            integrationWithDMS: "Yes",
            remarks: "Best before 6 months",
            shelfLife: "180 days",
            barCodeEAN: "8901234567890",
            minStockInDays: "10",
            leadTimeInDays: "5",
            maxStockInDays: "30",
            availabilityCheck: "Yes",
            transGroup: "TG-001",
            loadingGroup: "LG-005",
            profitCenter: "6001 (FMCG Division)",
            valuationClass: "4000 (Finished Goods)"
          }
          
          
        
      ];

     const handleCopyDuplicate=async(vendor)=>{
      localStorage.setItem("copiedMaterial", JSON.stringify(vendor));
      setToolTitle("Duplicate Copied")
      setTimeout(()=>{
        navigate("/material")
      },1000)
     }

     const handleEditMaterial=async()=>{
      localStorage.setItem("editMaterial", JSON.stringify(rawVendor));
      setTimeout(()=>{
        navigate("/material/edit")
      },1000)
     }

      const handleOpenDialog = (vendor) => {
        console.log("Raw Material>>> ", vendor.plant)
        setThePlant(vendor.plant)
        setRawVendor(vendor)
        setAllApproveDetails(vendor.all_approver_details)
        fetchAllMaterialLogs(vendor.material_id)
        console.log("mat type is>> ", approvalFields.ASSET)
        setSelectedVendor(vendor);
        fetchAllMaterialKDS()
        if(vendor.copied_from){
          // const matchedMaterial = allMaterials.find(item => item.material_id == vendor.copied_from);
          fetchOneMaterial(vendor.copied_from)
          // setCopiedMaterial(matchedMaterial);
          console.log("here is copied>>> ", vendor.copied_from)
        }
        // setOpenApp2(true)
        console.log("the row is>> ", vendor)
        const allowedFields = fieldOptions[vendor.material_type] || [];
        const additionalFields = approvalFields[vendor.material_type]?.map(field => 
          field.name.toLowerCase().replace(/\s+/g, "_")
        ) || [];
        setMaterialType(vendor.material_type)
        setMaterialStatus(vendor.approval_status)
        setApprovalData(vendor.approval_details);
        setLastApprover(vendor.lastapproval_details);
        setMaterialCreatedBy(vendor.created_by);
        setMaterialCreatedOn(vendor.created_on);
        console.log("printing approval details and approved status>> ", vendor.approval_details[0]?.user_id, vendor.approval_status)
        const allFields = [...allowedFields, ...additionalFields];
        const filteredData = Object.keys(vendor)
        .filter((key) => allFields.includes(key))
        .reduce((obj, key) => {
          obj[key] = vendor[key];
          return obj;
        }, {});

        console.log("the filter>> ", filteredData)

        const { approval_details, lastapproval_details, sap_response, sap_request, all_approver_details,...filteredVendor } = vendor;
        
        setSelectedMaterial(filteredVendor)
        // setMaterialType(vendor.materialType)
        // setMaterialStatus(vendor.properties[4].Approval_Status)
        // console.log("material is>> ",vendor.properties[4].Approval_Status)
        setOpenDialog(true);
        // setOpenApp2(true)
      };

      const getLastApprovedStatus = (dept) => {
        const lastLevel = approvalData.find((item) => item.dept === dept - 1);
        return lastLevel ? lastLevel.status === "1" : true; // true for level 1 (no previous approver)
      };

      const checkApprovalStatus = () => {
        const allApproved = approvalData.every((item) => item.status === "1");
        const anyRejected = approvalData.some((item) => item.status === "2");
      
        if (anyRejected) return "Material Rejected";
        if (allApproved) return "Material Approved";
        return null;
      };
    
      const handleCloseDialog = () => {
        setOpenDialog(false);
        // setIsEdit(false)
        setSelectedVendor(null);
      };


      // const handleFinalApprove=async()=>{

      // }

      const handleApproval=()=>{

        // setApproverType("Approve");
        
        if(lastApprover[0].user_id==userID){
         
            setOpenApp2(true)
            return;

        }else{
          setOpenComment(true)
          return

        }

        // if(isApp1){
        //     if(!toast.isActive(toastId.current)){
        //           toastId.current= toast.success("Material Approved",{
        //             className:"small-toast"
        //           })
        //         }
        //         setMaterialStatus("initialApproved")
        //         allvalues[selectedMaterial.materialType].Approval_Status= "initialApproved"
        //         localStorage.setItem("materialSaved", JSON.stringify(allvalues))
        // }else if(isApp2){
        //   if(!toast.isActive(toastId.current)){
        //     toastId.current= toast.success("Material Approved",{
        //       className:"small-toast"
        //     })
        //   }
        //   setMaterialStatus("finalApproved");
        //   allvalues[selectedMaterial.materialType].Approval_Status= "finalApproved"
        //   localStorage.setItem("materialSaved", JSON.stringify(allvalues))
        // }
        // else if(materialType==="FG" && isApp2){
        //   if(!toast.isActive(toastId.current)){
        //     toastId.current= toast.success("Material Approved",{
        //       className:"small-toast"
        //     })
        //   }
        //   setMaterialStatus("secondApproved");
        //   allvalues[selectedMaterial.materialType].Approval_Status= "secondApproved"
        //         localStorage.setItem("materialSaved", JSON.stringify(allvalues))
        // }else if(materialType==="FG" && isApp3){
        //   setOpenApp3(true)
        // }
      }

      const finishApproval=async()=>{
        setIsActive(true)
        const body={
          approvalid: approvalData[0].id,
          material_id: approvalData[0].material_id,
          user_id: approvalData[0].user_id,
          status: "1",
          comment: comment
        }
        try{
          const response= await approveMaterial(body);
          const res= response.data;
          if(res.status){

            if(!toast.isActive(toastId.current)){
              toastId.current= toast.success(res.message,{
                className:"small-toast"
              })
            }
            setOpenDialog(false);
            setOpenComment(false)
            setIsActive(false)
            fetchAllMaterials();
          }else{
            console.log("why not approve>> ", res);
            if(!toast.isActive(toastId.current)){
              toastId.current= toast.warning(res.message,{
                className:"small-toast"
              })
            }
            setIsActive(false)
          }
        }catch(err){
          console.log("Error in approving>> ", err)
          if(err.response?.status==403){
            if(!toast.isActive(toastId.current)){
              toastId.current= toast.error("Your Session has expired",{
                className:"small-toast"
              })
            }
            setTimeout(()=>{
              navigate("/")
              localStorage.clear();
            },2000)
            return;
          }
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.err(err.message,{
              className:"small-toast"
            })
          }
          setIsActive(false)
        }

      }

      const handleReject=()=>{

        setOpenComment2(true);
        
       
      }

      const finishRejection=async()=>{
        setIsActive(true)
        const body={
          approvalid: approvalData[0].id,
          material_id: approvalData[0].material_id,
          user_id: approvalData[0].user_id,
          comment:comment,
          status: "2"
        }
        console.log("rejection body>> ", body)
        try{
          const response= await approveMaterial(body);
          const res= response.data;
          if(res.status){

            if(!toast.isActive(toastId.current)){
              toastId.current= toast.success(res.message,{
                className:"small-toast"
              })
            }
            setOpenDialog(false);
            setOpenComment2(false)
            setIsActive(false)
            fetchAllMaterials();
          }else{
            console.log("why not reject>> ", res);

            if(!toast.isActive(toastId.current)){
              toastId.current= toast.warning(res.message,{
                className:"small-toast"
              })
            }
            setIsActive(false)
          }
        }catch(err){
          console.log("Error in rejecting>> ", err)
          if(err.response.status==403){
            if(!toast.isActive(toastId.current)){
              toastId.current= toast.error("Your Session has expired",{
                className:"small-toast"
              })
            }
            setTimeout(()=>{
              navigate("/")
              localStorage.clear();
            },2000)
            return;
          }
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.warning(err.message,{
              className:"small-toast"
            })
          }
          setIsActive(false)
        }

      }


      const handleDropdownClick = (field) => {
        setSelectedField(field);  // Store the selected field object
        setDialogOpen(true);      // Open the dialog
      };

      const handleSelect = (value,label) => {
        console.log("material type>> ", materialType)
        setApprovalFields((prev) => ({
          ...prev,
          [materialType]: prev[materialType].map((f) =>
            f.name === selectedField.name ? { ...f, value, label, defaultVal: value } : f
          ),
        }));
        setApprovalFields2((prevFields) => {
          console.log('prevFields:', prevFields); // Debug: Check if prevFields is correct
          if (!prevFields[materialType]) return prevFields; // Safety check
      
          const updatedStore = Object.fromEntries(
            Object.entries(prevFields[materialType]).map(([section, fields]) => [
              section,
              fields.map((f) => {
                // Log to check if field name matches
                
                return f.name === selectedField.name
                  ? { ...f, value, label, defaultVal: value }
                  : f;
              }),
            ])
          );
      
          // Debug: Check the updated store
      
          return { ...prevFields, [materialType]: updatedStore };
        });
        setDialogOpen(false);
        setSearchTerm("")
      };
      

      const handleChange = (materialType, fieldName, value) => {
        console.log("change>> ", value)
        setApprovalFields((prevApprovalFields) => {
          return {
            ...prevApprovalFields,
            [materialType]: prevApprovalFields[materialType].map((field) =>
              field.name === fieldName ? { ...field, value, defaultVal: value } : field
            ),
          };
        });
        setApprovalFields2((prevApprovalFields2) => {
          return {
            ...prevApprovalFields2,
            [materialType]: {
              ...prevApprovalFields2[materialType],
              ...Object.keys(prevApprovalFields2[materialType]).reduce((acc, section) => {
                acc[section] = prevApprovalFields2[materialType][section].map((field) =>
                  field.name === fieldName ? { ...field, value, defaultVal: value } : field
                );
                return acc;
              }, {}),
            },
          };
        });
      };

      useEffect(() => {
            const handler = setTimeout(() => {
              setSearchLoader(true); // Show loader AFTER 2 sec pause
              setDebouncedSearch(searchTerm);
          
              // Simulate async filtering (optional delay or set false immediately after)
              setTimeout(() => {
                setSearchLoader(false); // Hide loader after data is "ready"
              }, 100); // tweak delay if needed
            }, 600); // Wait for user to stop typing
          
            return () => clearTimeout(handler); // Cleanup if typing again
          }, [searchTerm]);
        
let list = kdsdata[selectedField?.apiKey] || [];

// Pre-filter by thePlant if Profit Center
if (selectedField?.name == "Profit Center" && thePlant) {
  const plantLower = thePlant.toString().toLowerCase();
  list = list?.filter((item) =>
    item.value.toString().toLowerCase().includes(plantLower)
  );
}

const filteredData = list.filter(
  (item) =>
    item.label.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
    item.value.toLowerCase().includes(debouncedSearch.toLowerCase())
);
      // const getFormattedDateTime = () => {
      //   const now = new Date();
      //   const year = now.getFullYear();
      //   const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      //   const day = String(now.getDate()).padStart(2, "0");
      //   const hours = String(now.getHours()).padStart(2, "0");
      //   const minutes = String(now.getMinutes()).padStart(2, "0");
      //   const seconds = String(now.getSeconds()).padStart(2, "0");
      
      //   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      // };

      const handleSubmit = async(e) => {
        setIsActive(true)
        e.preventDefault()

     
  const fieldsToValidate = approvalFields[materialType];

  console.log("here is to validate>> ", fieldsToValidate)
  // console.log("copied material details>>> ", approvalFields2)

  let isValid = true;
  let requiredFields  = ["Material Code","Mat Type", "Mat Grp", "Valuation Class", "Availability check", "MRP Type","Lot Sizing Procedure"];

  let missingFields = [];

  fieldsToValidate.forEach(field => {
    console.log("the field is >> ", field)
    if (requiredFields.includes(field.name)) {
      if (field.type === "text" || field.type === "number") {
        if ((!field.value || field.value.trim() === "") && field.defaultVal === undefined) {
          missingFields.push(field.name);
        }
      } else if (field.type === "dropdown") {
        if ((!field.value || field.value.trim() === "") && field.defaultVal === undefined) {
          missingFields.push(field.name);
        }
      }
       else if (field.type === "checkbox") {
        // Checkbox can be false but shouldn't be undefined/null
        if (field.value === undefined || field.value === null) {
          missingFields.push(field.name);
        }
      }
    }
  });
console.log("here are missing>> ", missingFields)
  if (missingFields.length > 0) {
    if(!toast.isActive(toastId.current)){
      toastId.current= toast.error(`Please fill the required fields: ${missingFields.join(", ")}`,{
        className:"small-toast"
      })

    }
    setIsActive(false);
    // alert(`Please fill the required fields: ${missingFields.join(", ")}`);
    return;
  }

  const updatedValues = { ...allvalues };

  Object.keys(approvalFields2).forEach((materialType) => {
    const newValues = {};
  
    Object.values(approvalFields2[materialType]).forEach((section) => {
      section.forEach((field) => {
        const formattedField = field.name.toLowerCase().replace(/\s+/g, "_");
  
        if (field.value === undefined || field.value === "") {
          newValues[formattedField] =
            field.defaultVal !== undefined && field.defaultVal !== "" ? field.defaultVal : "";
        } else {
          newValues[formattedField] = field.value;
        }
      });
    });
  
    updatedValues[materialType] = {
      ...newValues,
    };
  });
  
       console.log("updated>> ", updatedValues[materialType])

       const body1={
        ...updatedValues[materialType],
        material_name: selectedVendor.material_name,
        material_type: materialType,  
        approved_by: userID,

       }

       console.log("api body, ready>> ", body1)
       try{
        const response= await createMaterial(body1);
        const res1= response.data;
        if(res1.status){
          console.log("new material fields added>> ", res1);
          setIsActive(false)
          setOpenApp2(false)
          setOpenComment(true);
          
        }else{
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.warning(res1.message,{
              className:"small-toast"
            })
          }
          setIsActive(false)
        }
       }catch(error){
        console.log("Error in filling fields>> ", error)
        if(error.response?.status==403){
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.error("Your Session has expired",{
              className:"small-toast"
            })
          }
          setTimeout(()=>{
            navigate("/")
            localStorage.clear();
          },2000)
          return;
        }
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error(error.message,{
            className:"small-toast"
          })
        }
        setIsActive(false)  
       }

        setAllValues((prevAllValues) => {
          const updatedValues = { ...prevAllValues };
          if (approvalFields[materialType]) {
            const newValues = {};
            
            approvalFields[materialType].forEach((field) => {
              if (field.value !== undefined) {
                newValues[field.name] = field.value;
              }
            });
            
            updatedValues[materialType] = {
              // ...updatedValues[materialType],
              ...newValues,
            };
          }
          
          if (approvalFields[materialType]) {
            const newValues = {};
            
            approvalFields[materialType].forEach((field) => {
              if (field.value !== undefined) {
                newValues[field.name] = field.value;
              }
            });
            
            updatedValues[materialType] = {
              // ...updatedValues[materialType],
              ...newValues,
            };
          }

          console.log("here are updated values>> ", updatedValues[materialType])
          
          return updatedValues;
        });
      };

      const handleFGApproval=(e)=>{
        e.preventDefault();
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.success("Material Approved",{
            className:"small-toast"
          })
        }
        setMaterialStatus("finalApproved")
        allvalues[selectedMaterial.materialType].Approval_Status= "finalApproved"
        localStorage.setItem("materialSaved", JSON.stringify(allvalues))
      }

      

      return(
        <DashboardLayout>
            <DashboardNavbar/>
            <ToastContainer/>
            <>
            <SimpleBackdrop openLoader={isActive}/>
            <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px', flexWrap: 'wrap', marginBottom: '20px'  }}>
                <ButtonGroup className="mb-3" style={{ gap: "10px" }}>
                <Button
                  variant={selectedStatus === "all" ? "danger" : "outline-danger"}
                  onClick={() => {
                    setSelectedStatus("all")
                    fetchAllMaterials("all")}}
                 className="filterButton"
                >
                  All
                </Button>
                <Button
                  variant={selectedStatus === "pending" ? "danger" : "outline-danger"}
                  onClick={() =>{ 
                    setSelectedStatus("pending")
                    fetchAllMaterials("pending")}}
                  className="filterButton"
                >
                  Pending
                </Button>
                <Button
                  variant={selectedStatus === "approved" ? "danger" : "outline-danger"}
                  onClick={() => {
                    setSelectedStatus("approved")
                    fetchAllMaterials("approved")}}
                   className="filterButton"
                >
                  Approved
                </Button>
                <Button
                  variant={selectedStatus === "rejected" ? "danger" : "outline-danger"}
                  onClick={() => {
                    setSelectedStatus("rejected")
                    fetchAllMaterials("rejected")}}
                  className="filterButton"
                >
                  Rejected
                </Button>
               
              </ButtonGroup>
              <input
      type="text"
      placeholder="Search with name or SAP code"
      className="form-control searchMaterialBOX"
      style={{ fontSize: "12px"}}
      onChange={handleSearchChange}
    />
            </div>
            <div style={{overflowX:'auto'}}>

            <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
            <thead>
        <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>MATERIAL ID</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>MATERIAL TYPE</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>MATERIAL NAME</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>UOM</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0'}}>HSN CODE</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0'}}>SAP CODE</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0'}}>DOCUMENT STATUS</th>
         {selectedStatus!=="all" &&  <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0'}}>APPROVAL STATUS</th>}
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0'}}>CREATED BY</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0', align:'center'}}>ACTION</th>
        </tr>
      </thead>
     
     
        <tbody>
        {materialData.map((item, index) => (
      <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={index}>
         <td>{`#${item.material_id}`}</td>
        <td>{item.material_type}</td>
        <td>{item.material_name}</td>
        <td>{item.uom}</td>
        <td>{item.hsn_code}</td>
        <td>{item.sap_code}</td>
        <td>{item.approval_status.toUpperCase()}</td>
      {selectedStatus!=="all" && <td>{item.status==1?"APPROVED":item.status==2?"REJECTED":"PENDING"}</td>}  
      <td>{item.created_byname}</td>
        <td>
          <SoftButton variant="text" color="primary" onClick={() => handleOpenDialog(item)}>
            <Icon sx={{color:'red'}}>visibility</Icon>
          </SoftButton>
          <SoftButton variant="text" color="primary" onClick={() => handleCopyDuplicate(item)}>
  <Tooltip title={toolTitle}>
    <Icon sx={{color:'red'}}>copy</Icon>
  </Tooltip>
</SoftButton>
        </td>
      </tr>
    ))}
        </tbody>
        </Table>
            </div>
            </div>

        {/* <Pagination className="mt-3">
        <Pagination.Prev 
          disabled={currentPage === 1} 
          onClick={() => handlePageChange(currentPage - 1)}
        />
        {[...Array(totalPages).keys()].map((page) => (
          <Pagination.Item 
            key={page + 1} 
            active={page + 1 === currentPage} 
            onClick={() => handlePageChange(page + 1)}
          >
            {page + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next 
          disabled={currentPage === totalPages} 
          onClick={() => handlePageChange(currentPage + 1)}
        />
      </Pagination> */}


       <Pagination className="mt-3">
        <Pagination.Prev
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
          style={{
            color: "danger",
            borderRadius: "5px",
          }}
        />
      
        {/* Always show first page */}
        <Pagination.Item
          active={currentPage === 1}
          onClick={() => handlePageChange(1)}
          style={{
            color: currentPage === 1 ? "#fff" : "danger",
            backgroundColor: currentPage === 1 ? "danger" : "transparent",
            borderRadius: "5px",
          }}
        >
          1
        </Pagination.Item>
      
        {/* Left dots */}
        {currentPage > 3 && <Pagination.Ellipsis disabled />}
      
        {/* Middle page numbers */}
        {Array.from({ length: totalPages }, (_, i) => i + 1)
          .filter(
            (page) =>
              page !== 1 &&
              page !== totalPages &&
              Math.abs(currentPage - page) <= 1
          )
          .map((page) => (
            <Pagination.Item
              key={page}
              active={page === currentPage}
              onClick={() => handlePageChange(page)}
              style={{
                color: page === currentPage ? "#fff" : "danger",
                backgroundColor: page === currentPage ? "danger" : "transparent",
                borderRadius: "5px",
              }}
            >
              {page}
            </Pagination.Item>
          ))}
      
        {/* Right dots */}
        {currentPage < totalPages - 2 && <Pagination.Ellipsis disabled />}
      
        {/* Always show last page */}
        {totalPages > 1 && (
          <Pagination.Item
            active={currentPage === totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{
              color: currentPage === totalPages ? "#fff" : "danger",
              backgroundColor:
                currentPage === totalPages ? "danger" : "transparent",
              borderRadius: "5px",
            }}
          >
            {totalPages}
          </Pagination.Item>
        )}
      
        <Pagination.Next
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
          style={{
            color: "danger",
            borderRadius: "5px",
          }}
        />
      </Pagination>
            </>

        <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullScreen
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <span style={{ fontSize: '30px', color:'red', fontWeight:'bold' }}>Material Details</span>
    <SoftTypography color="error" variant="h5">{selectedMaterial?.sap_message}</SoftTypography>
    <IconButton
            edge="end"
            color="inherit"
            onClick={()=>setOpenDialog(false)} // You can define this function to close the dialog
            aria-label="close"
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

    <SoftBox display="flex" justifyContent="space-between" gap={2}>
      {/* {materialType === 'FG' ? (
        // When materialStatus is "finalApproved"
        materialStatus === 'finalApproved' ? (
          <SoftTypography color="success">Material Approved</SoftTypography>
        ) : materialStatus === 'pending' && isApp1 ? (
          // App1 can approve only when materialStatus is "pending"
          <>
            <SoftButton
              variant="contained"
              color="success"
              onClick={handleApproval}
            >
              Approve
            </SoftButton>
            <SoftButton
              variant="contained"
              color="error"
              
            >
              Reject
            </SoftButton>
          </>
        ) : materialStatus === 'initialApproved' && isApp1 ? (
          // App1 sees "Second Approval Pending" when materialStatus is "initialApproved"
          <SoftTypography color="warning">Second Approval Pending</SoftTypography>
        ) : materialStatus === 'secondApproved' && isApp1 ? (
          // App1 sees "Final Approval Pending" when materialStatus is "secondApproved"
          <SoftTypography color="warning">Final Approval Pending</SoftTypography>
        ) : materialStatus === 'secondApproved' && isApp2 ? (
          // App2 gets buttons when materialStatus is "secondApproved"
          <SoftTypography color="warning">Final Approval Pending</SoftTypography>
        ) : materialStatus === 'secondApproved' && isApp3 ? (
          // App3 gets buttons when materialStatus is "secondApproved"
          <>
            <SoftButton
              variant="contained"
              color="success"
              onClick={handleApproval}
            >
              Approve
            </SoftButton>
            <SoftButton
              variant="contained"
              color="error"
              
            >
              Reject
            </SoftButton>
          </>
        ) : (
          // When no special status, show disabled buttons for App2 and App3
          <>
            <SoftButton
              variant="contained"
              color="success"
              disabled
            >
              Approve
            </SoftButton>
            <SoftButton
              variant="contained"
              color="error"
              disabled
            >
              Reject
            </SoftButton>
          </>
        )
      ) : (
        isApp3? null : 
        materialStatus === 'finalApproved' ? (
          <SoftTypography color="success">Material Approved</SoftTypography>
        ) : materialStatus === 'finalRejected' || materialStatus === 'initialRejected' ? (
          <SoftTypography color="error">Material Rejected</SoftTypography>
        ): materialStatus === 'initialApproved' && isApp1 ?(
           <SoftTypography color="warning">Final Approval Pending</SoftTypography>
        ): materialStatus === 'initialApproved' && isApp2 ? (
          <>
          <SoftButton
            variant="contained"
            color="success"
            onClick={handleApproval}
          >
            Approve
          </SoftButton>
          <SoftButton
            variant="contained"
            color="error"
            
          >
            Reject
          </SoftButton>
        </>
        ):
         (
          <>
            <SoftButton
              variant="contained"
              color="success"
              onClick={handleApproval}
            >
              Approve
            </SoftButton>
            <SoftButton
              variant="contained"
              color="error"
              
            >
              Reject
            </SoftButton>
          </>
        )
      )} */}

      {approvalAllowed && approvalData[0]?.user_id==userID && materialStatus=== "pending" ? (


    <>
    
<SoftButton
              variant="contained"
              color="success"
              onClick={handleApproval}
            >
              Approve
            </SoftButton>
            <SoftButton
              variant="contained"
              color="error"
              onClick={handleReject}
            >
              Reject
            </SoftButton>
    </>  
      ): (
        <>
       {selectedVendor?.approval_status === "approved" ? (
  <SoftTypography color="success" variant="h5">Material Approved</SoftTypography>
) : selectedVendor?.approval_status === "rejected" ? (
  <SoftTypography color="error" variant="h5">Material Rejected</SoftTypography>
) : null}

        </>
      )

    }

    </SoftBox>
  </div>
</DialogTitle>

                <DialogContent>
                    <Tabs
                                              defaultActiveKey="profile"
                                              id="uncontrolled-tab-example"
                                              className="mb-3"
                                              activeKey={selectedTab}
                                              onSelect={(k)=>{
                                                
                                                setSelectedTab(k)}}
                                            >
                                              <Tab eventKey="details" title={<span style={{ fontSize: '15px', fontWeight: 'bold', color: '#FF0000' }}>Details</span>}>
                                              <form>
  <Select
    isDisabled
    value={[{value: materialType, label:materialType}]}
    styles={{
      ...customStyles,
      control: (provided) => ({
        ...provided,
        minHeight: "40px",
        fontSize: "14px",
      }),
    }}
  />
  
  {selectedMaterial && (
  <Card sx={{ mt: 3, p: 2, boxShadow: 3, borderRadius: 2 }}>
    <CardContent>
      {/* <SoftBox py={2} style={{ overflowX: "auto" }}>
        <Grid container alignItems="center" spacing={2}>
          {Object.entries(selectedMaterial)
           .filter(([_, value]) => value !== null && value !== undefined && value.toString().trim() !== "") // Exclude empty values
            .map(([field, value], index) => (
              <Grid item xs={3} key={index + field}>
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  gutterBottom
                  fontSize="12px"
                >
                  {field.replace(/_/g, " ").replace(/\b\w/g, (char) =>
                    char.toUpperCase()
                  )}
                </Typography>

                <SoftInput
                  type="text"
                  value={value} // Get value from selectedMaterial object
                  disabled
                  fullWidth
                />
              </Grid>
            ))}
        </Grid>
      </SoftBox> */}

<Table striped bordered hover style={{ fontSize: 11 }}>
  <tbody>
    {Object.entries(selectedMaterial)
      .filter(([field, value]) => field !== "belongs_to_details" && value !== null && value !== undefined && value.toString().trim() !== "")
      .reduce((rows, entry, index, arr) => {
        if (index % 2 === 0) {
          const secondEntry = arr[index + 1];
          rows.push([entry, secondEntry || null]);
        }
        return rows;
      }, [])
      .map((pair, idx) => (
        <tr key={idx}>
          {[pair[0], pair[1]].map((item, i) => {
            if (!item) {
              return (
                <>
                  <td key={i * 2}></td>
                  <td key={i * 2 + 1}></td>
                </>
              );
            }

            const label = item[0] === "created_byname"
              ? "Created By"
              : item[0]
                  .replace(/_/g, " ")
                  .replace(/\b\w+/g, word => {
                    const lower = word.toLowerCase();
                    if (lower === "hsn") return "HSN";
                    if (lower === "uom") return "UOM";
                    if (lower === "gr") return "GR";
                    if (lower.includes("mrp")) return word.toUpperCase();
                    return word.charAt(0).toUpperCase() + word.slice(1);
                  });

            let value = item[1];

            // 🧠 Show label from matgrp if it's Product Group Description
            if (label === "Product Group Description") {
              const match = kdsdata.matgrp.find(obj => obj.value === value);
              value = match ? match.label : value;
            }

            return (
              <React.Fragment key={i}>
                <td><strong>{label}</strong></td>
                <td>{value}</td>
              </React.Fragment>
            );
          })}
        </tr>
      ))}
  </tbody>
</Table>

{selectedMaterial?.belongs_to_details && (
  <>
    <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
      QUALITY SPECIFICATIONS ({selectedMaterial.belongs_to})
    </SoftTypography>
    <Table striped bordered hover size="sm" style={{ fontSize: 11 }}>
      <thead>
        <tr style={{ color: "white", backgroundColor: "#3498db" }}>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>PARAMETER NAME</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>LOWER LIMIT</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>STANDARD</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>UPPER LIMIT</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>UNIT/UOM</th>
        </tr>
      </thead>
      <tbody>
        {(() => {
          try {
            const specs = JSON.parse(selectedMaterial.belongs_to_details);
            if (!Array.isArray(specs) || specs.length === 0) {
              return <tr><td colSpan={5} style={{ textAlign: 'center' }}>No specifications configured</td></tr>;
            }
            return specs.map((item, idx) => (
              <tr key={idx}>
                <td><strong>{item.parameter}</strong></td>
                <td>{item.lower_limit || "-"}</td>
                <td>{item.standard || "-"}</td>
                <td>{item.upper_limit || "-"}</td>
                <td>{item.unit || "-"}</td>
              </tr>
            ));
          } catch (e) {
            return <tr><td colSpan={5} style={{ color: 'red' }}>Error parsing specifications: {e.message}</td></tr>;
          }
        })()}
      </tbody>
    </Table>
  </>
)}

<>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    APPROVER DETAILS
  </SoftTypography>
  <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
    <thead>
      <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVER NAME</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVER EMAIL</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVAL STATUS</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVED ON</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>COMMENT</th>
      </tr>
    </thead>
    <tbody>
      {allApproverDetails?.map((company) => (
        <tr key={company.id} className="border">
          <td className="border p-2">{company.approver_name}</td>
          <td className="border p-2">{company.email}</td>
          <td className="border p-2">
            {company.status}
          </td>
          <td className="border p-2">{company.approved_on}</td>
          <td className="border p-2">{company.comment}</td>
        </tr>
      ))}
    </tbody>
  </Table>
  </>





    </CardContent>
  </Card>
)}

  
    
 
</form>
                                              </Tab>
                                              <Tab eventKey="log" title={<span style={{ fontSize: '15px', fontWeight: 'bold', color: '#FF0000' }}>Log</span>}>
                                              <>
  <SoftTypography
    variant="h5"
    color="error"
    gutterBottom
    style={{ marginTop: 20, fontWeight: 'bold' }}
  >
    MATERIAL AUDIT LOG
  </SoftTypography>

  




{allAuditLogs?.length > 0 &&
  allAuditLogs.map((entry, i) => {
    const isUpdate = entry.action === 'UPDATE';
    const hasChangeData = isUpdate && Object.keys(entry.changedata || {}).length > 0;

    if (isUpdate && hasChangeData) {
      return (
        <div key={i} style={{ display: 'flex', alignItems: 'center', position: 'relative', borderLeft: '3px solid rgb(235, 85, 15)' }}>
          {/* Dot */}
          <div
            style={{
              position: 'absolute',
              left: -8,
              top: '50%',
              width: 14,
              height: 14,
              borderRadius: '50%',
              backgroundColor: 'rgb(235, 85, 15)',
              border: '2px solid white',
              boxShadow: '0 0 0 2px rgb(235, 85, 15)'
            }}
          />

          {/* Timestamp */}
          <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingLeft: 40, paddingRight: 50, fontStyle: 'italic' }}>
            {entry.created_at}
          </div>

          {/* Card */}
          <div
            style={{
              backgroundColor: '#f4f6f7',
              padding: 20,
              borderRadius: 8,
              border: '1px solid #ccc',
              fontSize: 13,
              width: '80%',
              marginBottom: 20,
            }}
          >
            <div style={{ fontSize: '14px', paddingTop: 10, width: '100%', display: 'flex', marginBottom: 15, alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '35px', height: '35px', borderRadius: '50%', backgroundColor: '#efefef', marginRight: 15, overflow: 'hidden' }}>
                  <img
                    src='https://www.transparentpng.com/thumb/user/gray-user-profile-icon-png-fP8Q1P.png'
                    alt="Profile"
                    style={{ width: '100%' }}
                  />
                </div>
                {/* <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingRight: 50, fontStyle: 'italic' }}> Admin</div> */}
              </div>
              <div style={{ backgroundColor: '#ceecdc', color: '#026933', padding: '3px', borderRadius: '5px' }}>{entry.action}</div>
            </div>

            {Object.entries(entry.changedata).map(([field, value], idx) => (
              <div key={idx} style={{ marginBottom: 10 }}>
                <div><strong>Field:</strong> {fieldDisplayNames[field] || '-'}</div>
                  <div><strong>Changed From:</strong> <del>{value?.old || '-'}</del> {' '}<strong>To:</strong> {value?.new || '-'}</div>
                
              </div>
            ))}

            <div><strong>Changed By:</strong> {entry.userdetails?.[0]?.name || '-'}</div>
          </div>
        </div>
      );
    } else if(entry.action === 'CREATE') {
      return (
        <div key={i} style={{ display: 'flex', alignItems: 'center', position: 'relative', borderLeft: '3px solid rgb(235, 85, 15)' }}>
          {/* Dot */}
          <div
            style={{
              position: 'absolute',
              left: -8,
              top: '50%',
              width: 14,
              height: 14,
              borderRadius: '50%',
              backgroundColor: 'rgb(235, 85, 15)',
              border: '2px solid white',
              boxShadow: '0 0 0 2px rgb(235, 85, 15)'
            }}
          />
          {/* Timestamp */}
          <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingLeft: 40, paddingRight: 50, fontStyle: 'italic' }}>
            {entry.created_at}
          </div>

          {/* Card */}
          <div
            style={{
              backgroundColor: '#f4f6f7',
              padding: 20,
              borderRadius: 8,
              border: '1px solid #ccc',
              fontSize: 13,
              width: '80%',
              marginBottom: 20,
            }}
          >
            <div style={{ fontSize: '14px', paddingTop: 10, width: '100%', display: 'flex', marginBottom: 15, alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '35px', height: '35px', borderRadius: '50%', backgroundColor: '#efefef', marginRight: 15, overflow: 'hidden' }}>
                  <img
                    src='https://www.transparentpng.com/thumb/user/gray-user-profile-icon-png-fP8Q1P.png'
                    alt="Profile"
                    style={{ width: '100%' }}
                  />
                </div>
                <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingRight: 50, fontStyle: 'italic' }}> Admin</div>
              </div>
              <div style={{ backgroundColor: '#ceecdc', color: '#026933', padding: '3px', borderRadius: '5px' }}>{entry.action}</div>
            </div>

            <div><strong>Material Created</strong> </div>
          </div>
        </div>
      );
    }else{
      return;
    }
  })}

  
</>
                                              </Tab>
                                            </Tabs>
                
                </DialogContent>
                <DialogActions>
                <Grid container spacing={2} mt={2}>
      <Grid item>
        <SoftButton variant="gradient" color="error" onClick={handleCloseDialog}>
          Close
        </SoftButton>
      </Grid>

      <Grid item>
        <SoftButton variant="gradient" color="error" onClick={handleEditMaterial}>
          Edit
        </SoftButton>
      </Grid>
    </Grid>
                </DialogActions>
      </Dialog>

      <Dialog open={openApp2}  fullScreen
        >

<DialogTitle>
<div style={{display:'flex', justifyContent:'space-between'}}>
<span style={{fontSize: "25px"}}>Approval Fields</span>
<SimpleBackdrop openLoader={isActive}/>
<IconButton
            edge="end"
            color="inherit"
            onClick={()=>setOpenApp2(false)} // You can define this function to close the dialog
            aria-label="close"
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
</div>
</DialogTitle>

<DialogContent>
  {materialType === "ASSET" ? (
    <form onSubmit={handleSubmit}>
    <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
      <CardContent>
        <SoftBox py={2} style={{ overflowX: "auto" }}>
        <Grid container spacing={3}>
    {/* Loop through each block */}
    {Object.keys(approvalFields2.ASSET).map((block, blockIndex) => (
      <Grid item xs={12} key={blockIndex}>
        {/* Render the block name as a header */}
        <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
          {block}
        </SoftTypography>
        {/* Loop through each field within the current block */}
        <Grid container spacing={2}>
          {approvalFields2.ASSET[block].map((field, index) => (
            <Grid item xs={12} sm={6} md={4} key={index + field.name}>
              <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px">
                {field.name}
              </Typography>
              {field.type === "dropdown" ? (
                <div onClick={() => handleDropdownClick(field)}>
                  <SoftInput
                    fullWidth
                    readOnly
                     value={field.defaultVal || field.label || "Select an option"}
                  />
                </div>
              ) : field.type === "text" ? (
                <SoftInput
                  type="text"
                  fullWidth
                  disabled={field.name==="Weight Unit"}
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "number" ? (
                <SoftInput
                  type="number"
                  fullWidth
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "checkbox" ? (
                <Checkbox
                  checked={field.value==="X"}
                  onChange={(e) => handleChange(materialType, field.name, e.target.checked ? 'X' : '')}
                />
              ) : null}
            </Grid>
          ))}
        </Grid>
      </Grid>
    ))}
  </Grid>
  
        </SoftBox>
      </CardContent>
      <SoftButton type="submit" color="success" variant="contained" mt={1}>
        Submit
      </SoftButton>
    </Card>
  </form>
  ) : materialType === "STORE" ? (
    <form onSubmit={handleSubmit}>
  <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
    <CardContent>
      <SoftBox py={2} style={{ overflowX: "auto" }}>
      <Grid container spacing={3}>
  {/* Loop through each block */}
  {Object.keys(approvalFields2.STORE).map((block, blockIndex) => (
    <Grid item xs={12} key={blockIndex}>
      {/* Render the block name as a header */}
      <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
          {block}
        </SoftTypography>
      {/* Loop through each field within the current block */}
      <Grid container spacing={2}>
        {approvalFields2.STORE[block].map((field, index) => (
          <Grid item xs={12} sm={6} md={4} key={index + field.name}>
            <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px">
              {field.name}
            </Typography>
            {field.type === "dropdown" ? (
              <div onClick={() => handleDropdownClick(field)}>
                <SoftInput
                  fullWidth
                  readOnly
                  value={field.defaultVal || field.label || "Select an option"}
                />
              </div>
            ) : field.type === "text" ? (
              <SoftInput
                type="text"
                fullWidth
                disabled={field.name==="Weight Unit"}
                value={field.defaultVal || field.value}
                onChange={(e) => handleChange(materialType, field.name, e.target.value)}
              />
            ) : field.type === "number" ? (
              <SoftInput
                type="number"
                fullWidth
                value={field.defaultVal || field.value}
                onChange={(e) => handleChange(materialType, field.name, e.target.value)}
              />
            ) : field.type === "checkbox" ? (
              <Checkbox
                checked={field.value==="X" || field.defaultVal==="X"}
                onChange={(e) => handleChange(materialType, field.name, e.target.checked ? 'X' : '')}
              />
            ) : null}
          </Grid>
        ))}
      </Grid>
    </Grid>
  ))}
</Grid>

      </SoftBox>
    </CardContent>
    <SoftButton type="submit" color="success" variant="contained" mt={1}>
      Submit
    </SoftButton>
  </Card>
</form>

  
  ): materialType === "BROKEN_SCRAP" ? (
    <form onSubmit={handleSubmit}>
  <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
    <CardContent>
      <SoftBox py={2} style={{ overflowX: "auto" }}>
      <Grid container spacing={3}>
  {/* Loop through each block */}
  {Object.keys(approvalFields2.BROKEN_SCRAP).map((block, blockIndex) => (
    <Grid item xs={12} key={blockIndex}>
      {/* Render the block name as a header */}
      <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
          {block}
        </SoftTypography>
      {/* Loop through each field within the current block */}
      <Grid container spacing={2}>
        {approvalFields2.BROKEN_SCRAP[block].map((field, index) => (
          <Grid item xs={12} sm={6} md={4} key={index + field.name}>
            <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px">
              {field.name}
            </Typography>
            {field.type === "dropdown" ? (
              <div onClick={() => handleDropdownClick(field)}>
                <SoftInput
                  fullWidth
                  readOnly
                   value={field.defaultVal || field.label || "Select an option"}
                />
              </div>
            ) : field.type === "text" ? (
              <SoftInput
                type="text"
                fullWidth
                disabled={field.name==="Weight Unit"}
                value={field.defaultVal || field.value}
                onChange={(e) => handleChange(materialType, field.name, e.target.value)}
              />
            ) : field.type === "number" ? (
              <SoftInput
                type="number"
                fullWidth
                value={field.defaultVal || field.value}
                onChange={(e) => handleChange(materialType, field.name, e.target.value)}
              />
            ) : field.type === "checkbox" ? (
              <Checkbox
                checked={field.value==="X" || field.defaultVal==="X"}
                onChange={(e) => handleChange(materialType, field.name, e.target.checked ? 'X' : '')}
              />
            ) : null}
          </Grid>
        ))}
      </Grid>
    </Grid>
  ))}
</Grid>

      </SoftBox>
    </CardContent>
    <SoftButton type="submit" color="success" variant="contained" mt={1}>
      Submit
    </SoftButton>
  </Card>
</form>

  
  ): materialType === "NON_VALUATED" ? (
    <form onSubmit={handleSubmit}>
  <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
    <CardContent>
      <SoftBox py={2} style={{ overflowX: "auto" }}>
      <Grid container spacing={3}>
  {/* Loop through each block */}
  {Object.keys(approvalFields2.NON_VALUATED).map((block, blockIndex) => (
    <Grid item xs={12} key={blockIndex}>
      {/* Render the block name as a header */}
      <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
          {block}
        </SoftTypography>
      {/* Loop through each field within the current block */}
      <Grid container spacing={2}>
        {approvalFields2.NON_VALUATED[block].map((field, index) => (
          <Grid item xs={12} sm={6} md={4} key={index + field.name}>
            <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px">
              {field.name}
            </Typography>
            {field.type === "dropdown" ? (
              <div onClick={() => handleDropdownClick(field)}>
                <SoftInput
                  fullWidth
                  readOnly
                   value={field.defaultVal || field.label || "Select an option"}
                />
              </div>
            ) : field.type === "text" ? (
              <SoftInput
                type="text"
                fullWidth
                disabled={field.name==="Weight Unit"}
                value={field.defaultVal || field.value}
                onChange={(e) => handleChange(materialType, field.name, e.target.value)}
              />
            ) : field.type === "number" ? (
              <SoftInput
                type="number"
                fullWidth
                value={field.defaultVal || field.value}
                onChange={(e) => handleChange(materialType, field.name, e.target.value)}
              />
            ) : field.type === "checkbox" ? (
              <Checkbox
                checked={field.value==="X" || field.defaultVal==="X"}
                onChange={(e) => handleChange(materialType, field.name, e.target.checked ? 'X' : '')}
              />
            ) : null}
          </Grid>
        ))}
      </Grid>
    </Grid>
  ))}
</Grid>

      </SoftBox>
    </CardContent>
    <SoftButton type="submit" color="success" variant="contained" mt={1}>
      Submit
    </SoftButton>
  </Card>
</form>

  
  ): materialType === "FREE_GOODS" ? (
    <form onSubmit={handleSubmit}>
  <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
    <CardContent>
      <SoftBox py={2} style={{ overflowX: "auto" }}>
      <Grid container spacing={3}>
  {/* Loop through each block */}
  {Object.keys(approvalFields2.FREE_GOODS).map((block, blockIndex) => (
    <Grid item xs={12} key={blockIndex}>
      {/* Render the block name as a header */}
      <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
          {block}
        </SoftTypography>
      {/* Loop through each field within the current block */}
      <Grid container spacing={2}>
        {approvalFields2.FREE_GOODS[block].map((field, index) => (
          <Grid item xs={12} sm={6} md={4} key={index + field.name}>
            <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px">
              {field.name}
            </Typography>
            {field.type === "dropdown" ? (
              <div onClick={() => handleDropdownClick(field)}>
                <SoftInput
                  fullWidth
                  readOnly
                   value={field.defaultVal || field.label || "Select an option"}
                />
              </div>
            ) : field.type === "text" ? (
              <SoftInput
                type="text"
                fullWidth
                disabled={field.name==="Weight Unit"}
                value={field.defaultVal || field.value}
                onChange={(e) => handleChange(materialType, field.name, e.target.value)}
              />
            ) : field.type === "number" ? (
              <SoftInput
                type="number"
                fullWidth
                value={field.defaultVal || field.value}
                onChange={(e) => handleChange(materialType, field.name, e.target.value)}
              />
            ) : field.type === "checkbox" ? (
              <Checkbox
                checked={field.value==="X" || field.defaultVal==="X"}
                onChange={(e) => handleChange(materialType, field.name, e.target.checked ? 'X' : '')}
              />
            ) : null}
          </Grid>
        ))}
      </Grid>
    </Grid>
  ))}
</Grid>

      </SoftBox>
    </CardContent>
    <SoftButton type="submit" color="success" variant="contained" mt={1}>
      Submit
    </SoftButton>
  </Card>
</form>

  
  ) : materialType === "RGP" ? (
    <form onSubmit={handleSubmit}>
    <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
      <CardContent>
        <SoftBox py={2} style={{ overflowX: "auto" }}>
        <Grid container spacing={3}>
    {/* Loop through each block */}
    {Object.keys(approvalFields2.RGP).map((block, blockIndex) => (
      <Grid item xs={12} key={blockIndex}>
        {/* Render the block name as a header */}
        <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
          {block}
        </SoftTypography>
        {/* Loop through each field within the current block */}
        <Grid container spacing={2}>
          {approvalFields2.RGP[block].map((field, index) => (
            <Grid item xs={12} sm={6} md={4} key={index + field.name}>
              <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px">
                {field.name}
              </Typography>
              {field.type === "dropdown" ? (
                <div onClick={() => handleDropdownClick(field)}>
                  <SoftInput
                    fullWidth
                    readOnly
                    
                     value={field.defaultVal || field.label || "Select an option"}
                  />
                </div>
              ) : field.type === "text" ? (
                <SoftInput
                  type="text"
                  fullWidth
                  disabled={field.name==="Weight Unit"}
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "number" ? (
                <SoftInput
                  type="number"
                  fullWidth
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "checkbox" ? (
                <Checkbox
                checked={field.value==="X" || field.defaultVal==="X"}
                  onChange={(e) => handleChange(materialType, field.name, e.target.checked ? 'X' : '')}
                />
              ) : null}
            </Grid>
          ))}
        </Grid>
      </Grid>
    ))}
  </Grid>
  
        </SoftBox>
      </CardContent>
      <SoftButton type="submit" color="success" variant="contained" mt={1}>
        Submit
      </SoftButton>
    </Card>
  </form>
  ) : materialType === "RM"? (
    <form onSubmit={handleSubmit}>
    <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
      <CardContent>
        <SoftBox py={2} style={{ overflowX: "auto" }}>
        <Grid container spacing={3}>
    {/* Loop through each block */}
    {Object.keys(approvalFields2.RM).map((block, blockIndex) => (
      <Grid item xs={12} key={blockIndex}>
        {/* Render the block name as a header */}
        <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
          {block}
        </SoftTypography>
        {/* Loop through each field within the current block */}
        <Grid container spacing={2}>
          {approvalFields2.RM[block].map((field, index) => (
            <Grid item xs={12} sm={6} md={4} key={index + field.name}>
              <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px">
                {field.name}
              </Typography>
              {field.type === "dropdown" ? (
                <div onClick={() => handleDropdownClick(field)}>
                  <SoftInput
                    fullWidth
                    readOnly
                    
                     value={field.defaultVal || field.label || "Select an option"}
                  />
                </div>
              ) : field.type === "text" ? (
                <SoftInput
                  type="text"
                  fullWidth
                  disabled={field.name==="Weight Unit"}
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "number" ? (
                <SoftInput
                  type="number"
                  fullWidth
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "checkbox" ? (
                <Checkbox
                checked={field.value==="X" || field.defaultVal==="X"}
                  onChange={(e) => handleChange(materialType, field.name, e.target.checked ? 'X' : '')}
                />
              ) : null}
            </Grid>
          ))}
        </Grid>
      </Grid>
    ))}
  </Grid>
  
        </SoftBox>
      </CardContent>
      <SoftButton type="submit" color="success" variant="contained" mt={1}>
        Submit
      </SoftButton>
    </Card>
  </form>
  ): materialType === "PM"? (
    <form onSubmit={handleSubmit}>
    <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
      <CardContent>
        <SoftBox py={2} style={{ overflowX: "auto" }}>
        <Grid container spacing={3}>
    {/* Loop through each block */}
    {Object.keys(approvalFields2.PM).map((block, blockIndex) => (
      <Grid item xs={12} key={blockIndex}>
        {/* Render the block name as a header */}
        <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
          {block}
        </SoftTypography>
        {/* Loop through each field within the current block */}
        <Grid container spacing={2}>
          {approvalFields2.PM[block].map((field, index) => (
            <Grid item xs={12} sm={6} md={4} key={index + field.name}>
              <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px">
                {field.name}
              </Typography>
              {field.type === "dropdown" ? (
                <div onClick={() => handleDropdownClick(field)}>
                  <SoftInput
                    fullWidth
                    readOnly
                    
                     value={field.defaultVal || field.label || "Select an option"}
                  />
                </div>
              ) : field.type === "text" ? (
                <SoftInput
                  type="text"
                  fullWidth
                  disabled={field.name==="Weight Unit"}
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "number" ? (
                <SoftInput
                  type="number"
                  fullWidth
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "checkbox" ? (
                <Checkbox
                checked={field.value==="X" || field.defaultVal==="X"}
                  onChange={(e) => handleChange(materialType, field.name, e.target.checked ? 'X' : '')}
                />
              ) : null}
            </Grid>
          ))}
        </Grid>
      </Grid>
    ))}
  </Grid>
  
        </SoftBox>
      </CardContent>
      <SoftButton type="submit" color="success" variant="contained" mt={1}>
        Submit
      </SoftButton>
    </Card>
  </form>
  )  : materialType === "SFG" ? (
    <form onSubmit={handleSubmit}>
    <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
      <CardContent>
        <SoftBox py={2} style={{ overflowX: "auto" }}>
        <Grid container spacing={3}>
    {/* Loop through each block */}
    {Object.keys(approvalFields2.SFG).map((block, blockIndex) => (
      <Grid item xs={12} key={blockIndex}>
        {/* Render the block name as a header */}
        <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
          {block}
        </SoftTypography>
        {/* Loop through each field within the current block */}
        <Grid container spacing={2}>
          {approvalFields2.SFG[block].map((field, index) => (
            <Grid item xs={12} sm={6} md={4} key={index + field.name}>
              <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px">
                {field.name}
              </Typography>
              {field.type === "dropdown" ? (
                <div onClick={() => handleDropdownClick(field)}>
                  <SoftInput
                    fullWidth
                    readOnly
                     value={field.defaultVal || field.label || "Select an option"}
                  />
                </div>
              ) : field.type === "text" ? (
                <SoftInput
                  type="text"
                  fullWidth
                  disabled={field.name==="Weight Unit"}
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "number" ? (
                <SoftInput
                  type="number"
                  fullWidth
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "checkbox" ? (
                <Checkbox
                checked={field.value==="X" || field.defaultVal==="X"}
                  onChange={(e) => handleChange(materialType, field.name, e.target.checked ? 'X' : '')}
                />
              ) : null}
            </Grid>
          ))}
        </Grid>
      </Grid>
    ))}
  </Grid>
  
        </SoftBox>
      </CardContent>
      <SoftButton type="submit" color="success" variant="contained" mt={1}>
        Submit
      </SoftButton>
    </Card>
  </form>
  ) : materialType === "FG" ?(
    <form onSubmit={handleSubmit}>
    <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
      <CardContent>
        <SoftBox py={2} style={{ overflowX: "auto" }}>
        <Grid container spacing={3}>
    {/* Loop through each block */}
    {Object.keys(approvalFields2.FG).map((block, blockIndex) => (
      <Grid item xs={12} key={blockIndex}>
        {/* Render the block name as a header */}
        <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
          {block}
        </SoftTypography>
        {/* Loop through each field within the current block */}
        <Grid container spacing={2}>
          {approvalFields2.FG[block].map((field, index) => (
            <Grid item xs={12} sm={6} md={4} key={index + field.name}>
              <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px">
                {field.name}
              </Typography>
              {field.type === "dropdown" ? (
                <div onClick={() => handleDropdownClick(field)}>
                  <SoftInput
                    fullWidth
                    readOnly
                     value={field.defaultVal || field.label || "Select an option"}
                  />
                </div>
              ) : field.type === "text" ? (
                <SoftInput
                  type="text"
                  fullWidth
                  disabled={field.name==="Weight Unit"}
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "number" ? (
                <SoftInput
                  type="number"
                  fullWidth
                  value={field.defaultVal || field.value}
                  onChange={(e) => handleChange(materialType, field.name, e.target.value)}
                />
              ) : field.type === "checkbox" ? (
                <Checkbox
                checked={field.value==="X" || field.defaultVal==="X"}
                  onChange={(e) => handleChange(materialType, field.name, e.target.checked ? 'X' : '')}
                />
              ) : null}
            </Grid>
          ))}
        </Grid>
      </Grid>
    ))}
  </Grid>
  
        </SoftBox>
      </CardContent>
      <SoftButton type="submit" color="success" variant="contained" mt={1}>
        Submit
      </SoftButton>
    </Card>
  </form>
  ):(
    <form>

    </form>
  )}
</DialogContent>




      </Dialog>

      <Dialog open={openApp3}  maxWidth="md"
        fullWidth>
          <SimpleBackdrop openLoader={isActive}/>

<DialogTitle>
<div style={{display:'flex', justifyContent:'space-between'}}>
<span style={{fontSize: "25px"}}>Approval Fields</span>
<IconButton
            edge="end"
            color="inherit"
            onClick={()=>setOpenApp3(false)} // You can define this function to close the dialog
            aria-label="close"
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
</div>
</DialogTitle>

<DialogContent>
  {materialType === "FG" ? (
    <form onSubmit={handleFGApproval}>
      <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
        <CardContent>
          <SoftBox py={2} style={{ overflowX: "auto" }}>
            <Grid container alignItems="center" spacing={2}>
              {approvalFields.FG.map((field, index) => (
                <Grid item xs={4} key={index + field.name}>
                  <Typography variant="body2" fontWeight="bold" gutterBottom fontSize="12px" >
                    {field.name}
                  </Typography>
                  {field.type === "dropdown" ? (
                     <div key={index} onClick={() => handleDropdownClick(field)}>
                     <SoftInput
                       fullWidth
                       readOnly
                       value={field.label || "Select an option"}
                     />
                   </div>
                  ) : field.type === "text" ? (
                    <SoftInput
                      type="text"
                      fullWidth
                      // label={field.name}
                      value={field.value}
                      onChange={(e)=> handleChange(materialType, field.name, e.target.value)}
                    />
                  ) : field.type === "checkbox" ? (
                    <Checkbox
                      checked={field.value}
                      onChange={(e)=> handleChange(materialType, field.name, e.target.checked)}
                    />
                  ) : null}
                </Grid>
              ))}
            </Grid>
          </SoftBox>
        </CardContent>
      <SoftButton type="submit" color="success" variant="contained" mt={1}>Submit</SoftButton>
      </Card>
    </form>
  ) : (
    <form>
      {/* Default form rendering if none of the material types match */}
    </form>
  )}
</DialogContent>




      </Dialog>

      <Dialog open={openComment} onClose={()=>setOpenComment(false)} maxWidth="xs" fullWidth>
         <SimpleBackdrop openLoader={isActive}/>
            <DialogTitle>Comment</DialogTitle>
            <DialogContent>
                <TextareaAutosize
                onChange={(e) => setComment(e.target.value)}
                    minRows={3}
                    placeholder="Write your comment..."
                    style={{ width: "100%", padding: "8px", fontSize: "14px", borderRadius: "4px", border: "1px solid #ccc" }}
                />
                <SoftButton onClick={finishApproval} color="success" variant="contained" mt={1}>Submit</SoftButton>
            </DialogContent>
        </Dialog>

        <Dialog open={openComment2} onClose={()=>setOpenComment2(false)} maxWidth="xs" fullWidth>
            <DialogTitle>Comment</DialogTitle>
            <DialogContent>
                <TextareaAutosize
                onChange={(e) => setComment(e.target.value)}
                    minRows={3}
                    placeholder="Write your comment..."
                    style={{ width: "100%", padding: "8px", fontSize: "14px", borderRadius: "4px", border: "1px solid #ccc" }}
                />
                <SoftButton onClick={finishRejection} color="success" variant="contained" mt={1}>Submit</SoftButton>
            </DialogContent>
        </Dialog>


        <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
          <SimpleBackdrop openLoader={searchLoader}/>
  <DialogTitle>Select an Option</DialogTitle>
  <DialogContent>
  <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: "100%",
            padding: "5px",
            marginBottom: "10px",
            fontSize: "12px",
          }}
        />
        <SoftButton
              onClick={() => handleSelect("","")}
              style={{
                marginBottom: "10px",
                backgroundColor: "#ccc",
                border: "none",
                padding: "5px 10px",
                fontSize: "12px",
                cursor: "pointer",
                borderRadius: "4px"
              }}
            >
              Clear Selection
            </SoftButton>
  <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
  <thead>
  <tr style={{ color: "white", backgroundColor: "#3498db" }}>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Label</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
        </tr>
      </thead>
      <tbody>
        {selectedField &&
          filteredData?.map((item, index) => (
            <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={index} onClick={() => handleSelect(item.value,item.label)}>
              <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.label}</th>
              <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.value}</th>
            </tr>
          ))}
      </tbody>
    </Table>
  </DialogContent>
</Dialog>

        </DashboardLayout>
      )
}

export default MaterialsList